<template>

  <div class="content-wrapper">
        <h4 class="print_hide card-title float-left"><span class="" style="font-weight: 300">{{$t('Group')}}: </span>{{group.name}}</h4>
        <div v-if="!hideForForms" class="print_show ">
          <h2 class="text-center" v-show="!hideForForms">{{filters.labelType != 'TEMPERATURE' ? $t(filters.labelType) : $t('Appliance Temperature')}}</h2>
          <h2 class="text-center " v-show="hideForForms">{{reportName}}</h2>
          <div class="float-left">
          <h4 class="card-title">{{category.name}}</h4>
            <h3 class="card-title">{{group.name}}</h3>
          </div>
          <div class="float-right">
            <h4 v-show="startDateFormatted != null && hideForForms === false" class="card-title">{{$t("Start Date")}}: <span class="float-right pl-2">{{ startDateFormatted}}</span></h4>
            <h4 v-show="endDateFormatted != null && hideForForms === false" class="card-title">{{$t("End Date")}}: <span class="float-right pl-2">{{ endDateFormatted}}</span></h4>
            <!--<h4 v-show="reportDate != null && hideForForms === true" class="card-title"><span class="float-right pl-2">{{ reportDate}}</span></h4>-->
          </div>
          <br><br>
        </div>
        <h4 class="print_hide" style="float:right"><span style="font-weight: 300">{{$t('Category')}}:</span>
          <b-link v-if="$store.state.user.data.role !== 'System Admin'" :append="true" style="display: inline;" :to="{path: `/company/${group.categoryId}`}">{{category.name}} </b-link>
          <b-link v-else :append="true" style="display: inline;" :to="{path: `/companies/${$route.params.company}/category/${group.categoryId}`}">{{category.name}} </b-link>
        </h4>
    <br><br>
        <b-tabs :lazy="true" v-model="tabIndex" class="group-tabs-view" content-class="bg-white">
          <b-tab :active="labelsBool" v-show="labelsBool" ref="labels" href="#labels" :title="$t('Labels')" id="labels">
            <b-container fluid class="no-padding">
              <!-- User Interface controls -->
              <div class="print_hide" style="background-color: #e8f4f9;padding: 15px;padding-bottom: 0;">
                <b-row>
                  <h4 class="pl-2">{{$t('Filters')}}</h4>
                  <b-col lg="12" class="my-1">
                    <b-form-group>
                      <b-form-radio-group
                        v-model="filters.labelType"
                        :options="labelTypes"
                        name="buttons-1"
                        buttons
                        button-variant="white"
                        @change="clearResults()"
                        :state="$v.filters.labelType.$dirty ? !$v.filters.labelType.$error : null"
                      >

                      </b-form-radio-group>
                      <div v-show="$v.filters.labelType.$error" class="text-danger"> {{$t('This is a required field.')}}</div>
                    </b-form-group>
                  </b-col>

                </b-row>
                <b-row>
                <b-col lg="4" class="my-1">
                  <b-form-group
                    :label="$t('Select Users')"
                    label-for="name-input"
                  >
                    <multiselect v-model="filters.users" :groupSelect="true" :optionHeight="10" :showLabels="false" deselectLabel="" selectLabel="" :options="usersOptions" :multiple="true" :close-on-select="false" :searchable="false" :clear-on-select="false" group-label="groupName" group-values="users" :taggable="false" :preserve-search="false" :placeholder="$t('Select User')" label="text" track-by="value" :preselect-first="false">
                      <!--<template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>-->
                    </multiselect>
                    <!--<b-form-select size="sm" v-model="filters.users" :options="usersOptions"></b-form-select>-->
                  </b-form-group>
                </b-col>
                <b-col lg="8" class="my-1">
                  <b-form-group
                    :label="$t('Date Range')"
                    label-for="name-input"
                  >
                    <v-date-picker
                      mode='range'
                      v-model="filters.dateRange"
                      show-caps
                      :max-date='new Date()'
                    >
                    </v-date-picker>
                    <button
                      type="button"
                      class="bg-white custom-calendar-clear"
                      @click="filters.dateRange = null">
                      Clear
                    </button>
                  </b-form-group>
                </b-col>
                <b-col lg="4" v-show="applianceFilter" class="my-1">
                  <b-form-group
                    :label="$t('Appliance No')"
                    label-for="appliance-input"
                  >
                    <b-form-input
                      min=0
                      id="appliance-input"
                      type="number"
                      v-model="filters.applianceNumber"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col lg="4" v-show="applianceTypeFilter" class="my-1">
                  <b-form-group
                    :label="$t('Appliance Type')"
                    label-for="appliance-input"
                  >
                    <b-form-select
                      size="sm"
                      v-model="filters.applianceType"
                      :options="applianceTypes"
                      required
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col lg="4" v-show="applianceStatusFilter" class="my-1">
                  <b-form-group
                    :label="$t('Appliance Status')"
                    label-for="appliance-input"
                  >
                    <b-form-select
                      size="sm"
                      v-model="filters.applianceStatus"
                      :options="applianceStatuses"
                      required
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col lg="4" class="my-1">
                  <b-form-group
                    :label="$t('Keyword Search')"
                    label-for="appliance-input"
                  >
                  <b-form-input
                    v-model="filters.keyword"
                    type="search"
                    :placeholder="$t('Keyword Search')"
                  ></b-form-input>
                  </b-form-group>
                </b-col>
                  <b-col lg="8" class="my-1">
                    <b-btn style="float:right;color:white;margin-bottom: 10px; margin-top: 10px;" variant="light" @click="searchLabels(true)"><i class="fa fa-search"></i>{{$t('Search')}}</b-btn>

                    <b-btn class="print_hide" style="float:right;color:white;margin-bottom: 10px;margin-top: 10px;margin-right: 10px" variant="light" @click="printExcelLabels()"><i class="fa fa-file-excel-o"></i> {{$t('Export Excel')}}</b-btn>
                  </b-col>
              </b-row>
              </div>
              <b-row>
                <b-col>
                  <h4 style="float:left;" class="pl-3 pt-3 print_hide">{{$t('Results')}}</h4>
                  <b-btn class="print_hide" v-show="labels.length > 0" style="float:right;color:white;margin-bottom: 10px;margin-top: 10px;margin-right: 10px" variant="light" @click="printLabels()"><i class="fa fa-file-pdf-o"></i> {{$t('Print Results')}}</b-btn>
                </b-col>
              </b-row>
              <!-- Main table element -->
              <div class="print_results">
              <b-table
                :busy.sync="isBusy"
                tbody-class="asdfgh"
                show-empty
                hover
                outlined
                stacked="true"
                :items="labels"
                :fields="labelFields"
                :current-page="currentPage"
                :per-page="0"
                :filterIncludedFields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :sort-compare="customCompare"
                @filtered="onFiltered"
              >
                <template v-slot:empty="scope">
                  <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
                </template>

                <template v-slot:cell(userId)="row">
                  <b-link class="nav-link no-padding print_hide" :to="'/users/'+row.item.userId"> {{ row.item.userName }} </b-link>
                  <div class="print_show">{{row.item.userName}}</div>
                </template>
                <template v-slot:cell(applianceType)="row">
                   {{$t(row.item.applianceType)}}
                </template>
                <template v-slot:cell(applianceStatus)="row">
                   {{$t(row.item.applianceStatus)}}
                </template>
                <template v-slot:cell(dayOut)="row">
                  {{row.item.dayOut}}
                </template>
                <template v-slot:cell(allergenOptions)="row">
                  <template v-for="allergen in row.item.allergenOptions">
                    <span v-bind:key="allergen">{{ $t(allergen)}},  </span>
                  </template>
                </template>
                <template v-slot:cell(allergenCodes)="row">
                  <template v-for="allergen in row.item.allergenCodes">
                    <span v-bind:key="allergen">{{ $t(allergen)}}, </span>
                  </template>
                </template>
                <template v-slot:cell(dateInAndOut)="row">
                  <div v-if="filters.labelType === 'BLAST_CHILLER'">
                    {{ row.item.dateIn }}
                  </div>
                  <div v-else>
                    {{ row.item.datetimeIn }}
                  </div>
                </template>
                <template v-slot:cell(temperatureIn)="row">
                    {{ row.item.temperatureIn }}°C
                </template>
                <template v-slot:cell(temperatureOut)="row">
                  {{ row.item.temperatureOut }}°C
                </template>
                <template v-slot:cell(actions)="row" >
                  <b-button variant="outline-dark" size="sm">
                    {{$t('Demo')}}
                  </b-button>
                </template>
              </b-table>
              </div>
              <b-row>
                <b-col lg="12" class="my-1 print_hide text-center">
                  <b-btn v-show="loadMoreBool" style="margin-bottom: 20px" pill variant="outline-secondary" @click="loadMore">{{$t('Load More')}}</b-btn>
                </b-col>
              </b-row>

            </b-container>
          </b-tab>
          <b-tab v-show="haccpBool" :title="$t('FORMS')" href="#forms" @click="fetchForms" id="haccp">
                <b-tabs>
                  <b-tab :title="$t('Form Results')" id="formsResultsNewTable">
                    <form-results :group="group" :category="category" :users="users"></form-results>
                  </b-tab>
<!--                  <b-tab :title="$t('Form Results')" id="formsResultsTable">-->
<!--                    <div v-if="formsResultsView" class="col-12 bg-white p-4 float-left forms-results-view">-->
<!--                      <div class="print_hide" style="background-color: #e8f4f9;padding: 15px;padding-bottom: 0;">-->
<!--                        <b-row>-->
<!--                          <h4 class="pl-2">{{$t('Filters')}}</h4>-->
<!--                        </b-row>-->
<!--                        <b-row>-->
<!--                          <b-col lg="6" class="my-1">-->
<!--                            <b-form-group-->
<!--                              :label="$t('Form')"-->
<!--                              label-for="name-input">-->
<!--                              &lt;!&ndash;<b-form-radio-group&ndash;&gt;-->
<!--                                &lt;!&ndash;v-model="formFilters.form"&ndash;&gt;-->
<!--                                &lt;!&ndash;:options="formsOptions"&ndash;&gt;-->
<!--                                &lt;!&ndash;name="buttons-01"&ndash;&gt;-->
<!--                                &lt;!&ndash;buttons&ndash;&gt;-->
<!--                                &lt;!&ndash;button-variant="white"&ndash;&gt;-->
<!--                                &lt;!&ndash;@change="clearResults()"&ndash;&gt;-->
<!--                                &lt;!&ndash;:state="$v.formFilters.form.$dirty ? !$v.formFilters.form.$error : null"&ndash;&gt;-->
<!--                              &lt;!&ndash;&gt;&ndash;&gt;-->

<!--                              &lt;!&ndash;</b-form-radio-group>&ndash;&gt;-->
<!--                              <b-form-select-->
<!--                                v-model="formFilters.form"-->
<!--                                :options="formsOptions"-->
<!--                              @change="clearResults()"-->
<!--                              ></b-form-select>-->
<!--                              &lt;!&ndash;<div v-show="$v.formFilters.form.$error" class="text-danger"> {{$t('This is a required field.')}}</div>&ndash;&gt;-->
<!--                            </b-form-group>-->
<!--                          </b-col>-->
<!--                          &lt;!&ndash;<b-col lg="3" class="my-1">&ndash;&gt;-->
<!--                            &lt;!&ndash;<b-form-group&ndash;&gt;-->
<!--                              &lt;!&ndash;:label="$t('Select Users')"&ndash;&gt;-->
<!--                              &lt;!&ndash;label-for="name-input"&ndash;&gt;-->
<!--                            &lt;!&ndash;&gt;&ndash;&gt;-->
<!--                              &lt;!&ndash;<multiselect v-model="formFilters.users" :groupSelect="true" :optionHeight="10" :showLabels="false" deselectLabel="" selectLabel="" :options="usersOptions" :multiple="true" :close-on-select="false" :searchable="false" :clear-on-select="false" group-label="groupName" group-values="users" :taggable="false" :preserve-search="false" :placeholder="$t('Select User')" label="text" track-by="value" :preselect-first="false">&ndash;&gt;-->
<!--                                &lt;!&ndash;&lt;!&ndash;<template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>&ndash;&gt;&ndash;&gt;-->
<!--                              &lt;!&ndash;</multiselect>&ndash;&gt;-->
<!--                              &lt;!&ndash;&lt;!&ndash;<b-form-select size="sm" v-model="filters.users" :options="usersOptions"></b-form-select>&ndash;&gt;&ndash;&gt;-->
<!--                            &lt;!&ndash;</b-form-group>&ndash;&gt;-->
<!--                          &lt;!&ndash;</b-col>&ndash;&gt;-->
<!--                          <b-col lg="4" class="my-1">-->
<!--                            <b-form-group-->
<!--                              :label="$t('Date Range')"-->
<!--                              label-for="name-input"-->
<!--                            >-->
<!--                              <v-date-picker-->
<!--                                mode='range'-->
<!--                                v-model="formFilters.dateRange"-->
<!--                                show-caps-->
<!--                                :max-date='new Date()'-->
<!--                              >-->
<!--                              </v-date-picker>-->
<!--                              <button-->
<!--                                type="button"-->
<!--                                class="bg-white custom-calendar-clear"-->
<!--                                @click="formFilters.dateRange = null">-->
<!--                                Clear-->
<!--                              </button>-->
<!--                              &lt;!&ndash;<div v-show="$v.formFilters.dateRange.$error" class="text-danger"> {{$t('This is a required field.')}}</div>&ndash;&gt;-->

<!--                            </b-form-group>-->
<!--                          </b-col>-->
<!--                          <b-col lg="2" class="my-1">-->

<!--                            <b-btn style="float:right;color:white;margin-bottom: 15px; margin-top: 22px;" variant="light" @click="searchForms(true)"><i class="fa fa-search"></i>{{$t('Search')}}</b-btn>-->
<!--                            <b-btn v-show="formsResults.length > 0" style="float:right;color:white;margin-bottom: 15px; margin-top: 22px;" variant="light" @click="prePrintAll()"><i class="fa fa-print"></i>{{$t('Print All')}}</b-btn>-->
<!--                          </b-col>-->
<!--                        </b-row>-->
<!--                      </div>-->

<!--                      <b-table-->
<!--                      show-empty-->
<!--                      hover-->
<!--                      stacked="true"-->
<!--                      :items="formsResults"-->
<!--                      :fields="formResultFields"-->
<!--                      :current-page="currentFormResultPage"-->
<!--                      :per-page="perPage"-->
<!--                      :filter="filter"-->
<!--                      :filterIncludedFields="filterOn"-->
<!--                      :sort-by.sync="formResultFieldsSortBy"-->
<!--                      :sort-desc.sync="sortDesc"-->
<!--                      :sort-direction="sortDirection"-->
<!--                      :sort-compare="customCompare"-->
<!--                      @filtered="onFiltered"-->
<!--                    >-->
<!--                      <template v-slot:empty="scope">-->
<!--                        <div class="text-center my-2"> {{$t('There are no records to show')}} </div>-->
<!--                      </template>-->
<!--                      &lt;!&ndash;<template v-slot:cell(name)="row">&ndash;&gt;-->
<!--                        &lt;!&ndash;<b-link class="nav-link no-padding" :to="'/users/'+row.item.id"> {{ row.item.firstName }} {{ row.item.lastName }} </b-link>&ndash;&gt;-->
<!--                      &lt;!&ndash;</template>&ndash;&gt;-->

<!--                      <template v-slot:cell(status)="row">-->
<!--                        <label :class="row.item.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.status) }}</label>-->
<!--                      </template>-->

<!--                      <template v-slot:cell(actions)="row" >-->
<!--                        <b-button variant="outline-light" size="sm" @click="prePrint(row.item)">-->
<!--                          <i class="fa fa-print" style="margin:0"></i>-->
<!--                        </b-button>-->
<!--                        <b-button variant="outline-light" size="sm" @click="showReport(row.item)">-->
<!--                          {{$t('Show Report')}}-->
<!--                        </b-button>-->
<!--                      </template>-->
<!--                    </b-table>-->
<!--                    <b-pagination-->
<!--                      v-model="currentFormResultPage"-->
<!--                      :total-rows="totalFormResultRows"-->
<!--                      :per-page="perPage"-->
<!--                      align="center"-->
<!--                      class="my-5"-->
<!--                    ></b-pagination>-->
<!--                    </div>-->
<!--                    <div v-else class="col-12 bg-white p-4 float-left single-form-results-view">-->
<!--                     <b-row class="pb-3 print_hide" style="display: inline-block;width: 100%;">-->
<!--                       <b-link class="print_hide" :append="true"-->
<!--                               v-on:click="formsResultsView= true"><i class="fa fa-chevron-left"></i> {{$t('Back to Results') }}-->
<!--                       </b-link>-->
<!--                       <b-btn class="print_hide" v-show="massReportRows.length > 0" style="float:right;color:white;margin-bottom: 10px;margin-top: 10px;margin-right: 10px" variant="light" @click="printFormResults()"><i class="fa fa-print"></i> {{$t('Print Results')}}</b-btn>-->
<!--                     </b-row>-->
<!--                      <b-row>-->
<!--                        <b-col lg="8" class="my-1 print_hide">-->
<!--                          <h4 class="pl-2 ">{{reportName}}</h4>-->
<!--                        </b-col>-->
<!--                        &lt;!&ndash;<b-col class="text-right pr-4 print_hide">&ndash;&gt;-->
<!--                          &lt;!&ndash;<span>{{reportDate}}</span>&ndash;&gt;-->
<!--                        &lt;!&ndash;</b-col>&ndash;&gt;-->
<!--                      </b-row>-->
<!--                      <template v-for="(reportRows, ind) in massReportRows">-->
<!--                        <div class="break-tr" v-bind:key="ind+'ad'" >-->
<!--                          <div style="text-align: right;font-size: 18px;font-weight: 500;margin-bottom: 50px;">-->
<!--                            <div class="print_show ">-->
<!--                              <h2 class="text-center" v-show="!hideForForms">{{filters.labelType != 'TEMPERATURE' ? $t(filters.labelType) : $t('Appliance Temperature')}}</h2>-->
<!--                              <h2 class="text-center mb-5" v-show="hideForForms">{{reportRows.name}}</h2>-->
<!--                              <div class="float-left mt-4">-->
<!--                                <h4 class="card-title">{{category.name}}</h4>-->
<!--                                <h3 class="card-title">{{group.name}}</h3>-->
<!--                              </div>-->
<!--                              <div class="float-right mt-4">-->
<!--                                <h4 v-show="startDateFormatted != null && hideForForms === false" class="card-title">{{$t("Start Date")}}: <span class="float-right pl-2">{{ startDateFormatted}}</span></h4>-->
<!--                                <h4 v-show="endDateFormatted != null && hideForForms === false" class="card-title">{{$t("End Date")}}: <span class="float-right pl-2">{{ endDateFormatted}}</span></h4>-->
<!--                                <h4 class="card-title"><span class="float-right pl-2">{{reportRows.date}}</span></h4>-->
<!--                              </div>-->
<!--                              <br><br>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <table v-bind:key="ind" class="table table-bordered">-->
<!--                          <thead style="background-color: #e9f4f9;border: 2px solid #c8e9f8;">-->
<!--                          <th style="width: 170px;">User</th>-->
<!--                          <th style="width: 120px;">Time</th>-->
<!--                          <th  style="width: 250px;">Name</th>-->
<!--                          <th >Result</th>-->
<!--                          </thead>-->
<!--                          <tbody style="border: 2px solid #c8e9f8;">-->

<!--                          <template v-for="(row, rowIndex) in reportRows.data">-->
<!--                          <template v-if="row.results.length > 0">-->
<!--                          <template v-for="(result,indexx) in row.results">-->
<!--                            &lt;!&ndash;<template v-if="result.order === row.order">&ndash;&gt;-->
<!--                              <tr :style="indexx === 0? '    border-top: 2px solid rgb(200, 233, 248);' : ''" v-bind:key="indexx+ind+'-'+rowIndex">-->
<!--                                <td v-bind:key="result.userId+ind+indexx">-->
<!--                                  <span style="margin-right: 5px;float: left;">{{indexx+1}}</span>-->
<!--                                  <b-link  class="nav-link no-padding print_hide" :to="'/users/'+result.userId"> {{result.userName}} </b-link>-->
<!--                                  <div class="print_show">{{result.userName}}</div>-->
<!--                                </td>-->
<!--                                <td v-bind:key="result.recordedAt+ind+indexx">{{result.recordedAt}}</td>-->
<!--                                <th :rowspan="row.results.length"  v-bind:key="result.name+ind+indexx" v-if="indexx === 0" >{{row.name}}</th>-->
<!--                                <td v-html="result.value" v-bind:key="result.value+ind+indexx">{{result.value}}</td>-->
<!--                              </tr>-->
<!--                            &lt;!&ndash;</template>&ndash;&gt;-->
<!--                            &lt;!&ndash;<template v-else>&ndash;&gt;-->
<!--                              &lt;!&ndash;<td v-bind:key="result" colspan="3">empty?</td>&ndash;&gt;-->
<!--                            &lt;!&ndash;</template>&ndash;&gt;-->
<!--                          </template>-->
<!--                          </template>-->
<!--                          <template v-else>-->
<!--                            <tr style="border-top: 2px solid rgb(200, 233, 248);" v-bind:key="rowIndex">-->
<!--                              <th v-if="row.type !== 'NOTE'"></th>-->
<!--                              <th v-if="row.type !== 'NOTE'"></th>-->
<!--                              <th :colspan="row.type === 'NOTE'? 4 : 1" ><div style="white-space: pre-wrap;" v-html="row.name"></div></th>-->
<!--                              <template v-if="row.type !== 'NOTE'">-->
<!--                                <td ></td>-->
<!--                              </template>-->

<!--                            </tr>-->
<!--                          </template>-->
<!--                          </template>-->
<!--                          </tbody>-->
<!--                        </table>-->
<!--                      </template>-->
<!--                    </div>-->
<!--                  </b-tab>-->
                  <!--<b-tab :title="$t('Monthly Reports')" id="monthlyReport">-->
                    <!--<div class="col-12 bg-white p-4 float-left forms-results-view">-->
                      <!--<b-row>-->
                        <!--<h4 style="width: 100%" class="pl-2">{{$t('Forms')}}</h4>-->
                        <!--<b-col lg="6" class="my-1">-->
                          <!--<b-form-group>-->
                              <!--<b-form-group-->
                                <!--:label="$t('Form')"-->
                                <!--label-for="name-input">-->
                                <!--&lt;!&ndash;<b-form-radio-group&ndash;&gt;-->
                                <!--&lt;!&ndash;v-model="formFilters.form"&ndash;&gt;-->
                                <!--&lt;!&ndash;:options="formsOptions"&ndash;&gt;-->
                                <!--&lt;!&ndash;name="buttons-01"&ndash;&gt;-->
                                <!--&lt;!&ndash;buttons&ndash;&gt;-->
                                <!--&lt;!&ndash;button-variant="white"&ndash;&gt;-->
                                <!--&lt;!&ndash;@change="clearResults()"&ndash;&gt;-->
                                <!--&lt;!&ndash;:state="$v.formFilters.form.$dirty ? !$v.formFilters.form.$error : null"&ndash;&gt;-->
                                <!--&lt;!&ndash;&gt;&ndash;&gt;-->

                                <!--&lt;!&ndash;</b-form-radio-group>&ndash;&gt;-->
                                <!--<b-form-select-->
                                  <!--v-model="formFilters.form"-->
                                  <!--:options="formsOptions"-->
                                  <!--@change="clearResults()"-->
                                  <!--:state="$v.formFilters.form.$dirty ? !$v.formFilters.form.$error : null"-->

                                <!--&gt;</b-form-select>-->
                                <!--<div v-show="$v.formFilters.form.$error" class="text-danger"> {{$t('This is a required field.')}}</div>-->
                              <!--</b-form-group>-->
                            <!--<div v-show="$v.filters.labelType.$error" class="text-danger"> {{$t('This is a required field.')}}</div>-->
                          <!--</b-form-group>-->
                        <!--</b-col>-->
                        <!--<b-col lg="3" class="my-1">-->
                          <!--<b-form-group>-->
                              <!--<b-form-group-->
                                <!--:label="$t('Month')"-->
                                <!--label-for="name-input">-->
                                <!--&lt;!&ndash;<b-form-radio-group&ndash;&gt;-->
                                <!--&lt;!&ndash;v-model="formFilters.form"&ndash;&gt;-->
                                <!--&lt;!&ndash;:options="formsOptions"&ndash;&gt;-->
                                <!--&lt;!&ndash;name="buttons-01"&ndash;&gt;-->
                                <!--&lt;!&ndash;buttons&ndash;&gt;-->
                                <!--&lt;!&ndash;button-variant="white"&ndash;&gt;-->
                                <!--&lt;!&ndash;@change="clearResults()"&ndash;&gt;-->
                                <!--&lt;!&ndash;:state="$v.formFilters.form.$dirty ? !$v.formFilters.form.$error : null"&ndash;&gt;-->
                                <!--&lt;!&ndash;&gt;&ndash;&gt;-->

                                <!--&lt;!&ndash;</b-form-radio-group>&ndash;&gt;-->
                                <!--<vue-monthly-picker-->
                                  <!--:inputClass="{'input': isDisplayInput}"-->
                                  <!--:disabled="isDisable"-->
                                  <!--:monthLabels="locale"-->
                                  <!--:clearOption="clearOption"-->
                                  <!--:min="min"-->
                                  <!--:max="max"-->
                                  <!--@selected="handleSelect"-->
                                  <!--v-model="monthlyFormFilters.month"-->
                                  <!--:alignment="alignment"-->
                                  <!--:selectedBackgroundColor="selectedBackgroundColor"-->
                                  <!--:state="$v.monthlyFormFilters.month.$dirty ? !$v.monthlyFormFilters.month.$error : null"-->
                                <!--&gt;-->
                                <!--</vue-monthly-picker>-->
                                <!--<div v-show="$v.monthlyFormFilters.month.$error" class="text-danger"> {{$t('This is a required field.')}}</div>-->
                              <!--</b-form-group>-->
                          <!--</b-form-group>-->
                        <!--</b-col>-->

                      <!--</b-row>-->
                    <!--</div>-->
                  <!--</b-tab>-->
                  <b-tab :title="$t('Forms')" id="formsTable">
                    <div  class="col-12 bg-white p-4 float-left">

                        <b-row>
                          <h4 class="pl-2">{{$t('Group Forms')}}</h4>
                        <b-col align-self="end">
                          <b-btn style="float:right;color:white" variant="light" @click="createFormModal" >{{$t('Create Form')}}</b-btn>
                        </b-col>
                      </b-row>
                        <b-row style="float:right;" class="pt-2">
                          <b-col align-self="end">
                            <b-form-checkbox @change="switchInactive()" size="lg" v-model="includeInactive" name="check-button" switch>
                              Include inactive forms
                            </b-form-checkbox>
                          </b-col>
                        </b-row>

                      <b-table
                      show-empty
                      hover
                      stacked="true"
                      :items="forms"
                      :fields="formFields"
                      :current-page="currentFormPage"
                      :per-page="perPage"
                      :sort-by.sync="formsSortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      :sort-compare="customCompare"
                    >
                      <template v-slot:empty="scope">
                        <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
                      </template>
                      <template v-slot:cell(name)="row">
                        <!--<b-link class="nav-link no-padding" :to="'/groups/'+groupId+'/forms/'+row.item.id"> {{ row.item.name }} </b-link>-->
                        <b-link @click="mapFormUpdate(row)" >{{ row.item.name }}</b-link>

                      </template>

                      <template v-slot:cell(status)="row">
                        <label :class="row.item.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.status) }}</label>
                      </template>

                      <template v-slot:cell(actions)="row" >
                        <b-button v-if="['System Admin', 'Administrator', 'Manager'].includes($store.state.user.data.role)" variant="outline-primary" size="sm" @click="mapCloneForm(row.item.id)">
                          {{$t('Clone')}}
                        </b-button>
                        <b-button v-if="['System Admin', 'Administrator'].includes($store.state.user.data.role)" variant="outline-primary" size="sm" @click="mapFormUpdate(row)">
                          {{$t('Edit')}}
                        </b-button>
                        <b-button v-if="['System Admin', 'Administrator'].includes($store.state.user.data.role)" variant="outline-danger" size="sm" @click="deleteForm(row.item.id)">
                          {{$t('Remove')}}
                        </b-button>
                      </template>
                    </b-table>
                      <b-pagination
                      v-model="currentFormPage"
                      :total-rows="forms.length"
                      :per-page="perPage"
                      align="center"
                      class="my-5"
                    ></b-pagination>
                    </div>
                  </b-tab>
                </b-tabs>
          </b-tab>
          <b-tab v-show="sensorBool" :title="$t('Devices')" href="#sensors" @click="fetchSensors" id="sensors">
            <b-tabs>
              <b-tab :title="$t('Sensor Logs')" id="sensorsResultsTable">
                <div v-if="formsResultsView" class="col-12 bg-white p-4 float-left sensors-results-view">
                  <div class="print_hide" style="background-color: #e8f4f9;padding: 15px;padding-bottom: 0;">
                    <b-row>
                      <h4 class="pl-2">{{$t('Filters')}}</h4>
                    </b-row>
                    <b-row>
                      <b-col lg="6" class="my-1">
                        <b-form-group
                          :label="$t('Appliance Number')"
                          label-for="name-input">
                          <!--<b-form-radio-group-->
                          <!--v-model="formFilters.form"-->
                          <!--:options="formsOptions"-->
                          <!--name="buttons-01"-->
                          <!--buttons-->
                          <!--button-variant="white"-->
                          <!--@change="clearResults()"-->
                          <!--:state="$v.formFilters.form.$dirty ? !$v.formFilters.form.$error : null"-->
                          <!--&gt;-->

                          <!--</b-form-radio-group>-->
                          <multiselect
                            size="sm"
                            :multiple="true"
                            v-model="sensorFilters.applianceNumber"
                            group-values="sensors"
                            group-label="gatewayName"
                            :group-select="true"
                            label="text"
                            track-by="value"
                            :options="sensorsOptions"
                            @change="clearResults()"
                          ></multiselect>
                          <!--<div v-show="$v.formFilters.form.$error" class="text-danger"> {{$t('This is a required field.')}}</div>-->
                        </b-form-group>
                      </b-col>
                      <b-col lg="6" class="my-1">
                        <b-form-group
                          :label="$t('Appliance Type')"
                          label-for="appliance-input"
                        >
                          <b-form-select
                            size="sm"
                            v-model="sensorFilters.applianceType"
                            :options="applianceTypes"
                            required
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                      <!--<b-col lg="3" class="my-1">-->
                      <!--<b-form-group-->
                      <!--:label="$t('Select Users')"-->
                      <!--label-for="name-input"-->
                      <!--&gt;-->
                      <!--<multiselect v-model="formFilters.users" :groupSelect="true" :optionHeight="10" :showLabels="false" deselectLabel="" selectLabel="" :options="usersOptions" :multiple="true" :close-on-select="false" :searchable="false" :clear-on-select="false" group-label="groupName" group-values="users" :taggable="false" :preserve-search="false" :placeholder="$t('Select User')" label="text" track-by="value" :preselect-first="false">-->
                      <!--&lt;!&ndash;<template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>&ndash;&gt;-->
                      <!--</multiselect>-->
                      <!--&lt;!&ndash;<b-form-select size="sm" v-model="filters.users" :options="usersOptions"></b-form-select>&ndash;&gt;-->
                      <!--</b-form-group>-->
                      <!--</b-col>-->
                      <b-col lg="6" class="my-1">
                        <b-form-group
                          :label="$t('Date Range')"
                          label-for="name-input"
                        >
                          <v-date-picker
                            size="sm"
                            mode='range'
                            v-model="sensorFilters.dateRange"
                            show-caps
                            :max-date='new Date()'
                          >
                          </v-date-picker>
                          <button
                            type="button"
                            class="bg-white custom-calendar-clear"
                            @click="sensorFilters.dateRange = null">
                            Clear
                          </button>
                          <!--<div v-show="$v.formFilters.dateRange.$error" class="text-danger"> {{$t('This is a required field.')}}</div>-->

                        </b-form-group>
                      </b-col>
                      <b-col lg="6" class="my-1">

                        <b-btn style="float:right;color:white;margin-bottom: 15px; margin-top: 22px;" variant="light" @click="fetchSensorLogs(true)"><i class="fa fa-search"></i>{{$t('Search')}}</b-btn>
                        <b-btn v-show="sensorResults.length > 0" style="float:right;color:white;margin-bottom: 15px; margin-top: 22px;" variant="light" @click="printSensorLogs()"><i class="fa fa-print"></i>{{$t('Print All')}}</b-btn>

                      </b-col>
                    </b-row>
                  </div>

                  <b-table
                    show-empty
                    hover
                    stacked="true"
                    :items="sensorResults"
                    :fields="sensorResultFields"
                    :current-page="currentSensorResultPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filterIncludedFields="filterOn"
                    :sort-by.sync="sensorResultFieldsSortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :sort-compare="customCompare"
                  >
                    <template v-slot:empty="scope">
                      <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
                    </template>
                    <template v-slot:cell(applianceType)="row">
                      {{$t(row.item.applianceType)}}
                    </template>
                    <template v-slot:cell(temperature)="row">
                        <div>{{parseFloat(row.item.temperature).toFixed(2)}} ℃</div>
                    </template>
                    <template v-slot:cell(actions)="row" >
                      <b-button variant="outline-light" size="sm" @click="prePrint(row.item)">
                        <i class="fa fa-print" style="margin:0"></i>
                      </b-button>
                      <b-button variant="outline-light" size="sm" @click="showReport(row.item)">
                        {{$t('Show Report')}}
                      </b-button>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="currentSensorResultPage"
                    :total-rows="totalSensorResultRows"
                    :per-page="perPage"
                    align="center"
                    class="my-5"
                  ></b-pagination>
                </div>
                <div v-else class="col-12 bg-white p-4 float-left single-form-results-view">
                  <b-row class="pb-3 print_hide" style="display: inline-block;width: 100%;">
                    <b-link class="print_hide" :append="true"
                            v-on:click="formsResultsView= true"><i class="fa fa-chevron-left"></i> {{$t('Back to Results') }}
                    </b-link>
                    <b-btn class="print_hide" v-show="massReportRows.length > 0" style="float:right;color:white;margin-bottom: 10px;margin-top: 10px;margin-right: 10px" variant="light" @click="printFormResults()"><i class="fa fa-print"></i> {{$t('Print Results')}}</b-btn>
                  </b-row>
                  <b-row>
                    <b-col lg="8" class="my-1 print_hide">
                      <h4 class="pl-2 ">{{reportName}}</h4>
                    </b-col>
                    <!--<b-col class="text-right pr-4 print_hide">-->
                    <!--<span>{{reportDate}}</span>-->
                    <!--</b-col>-->
                  </b-row>
                  <template v-for="(reportRows, ind) in massReportRows">
                    <div class="break-tr" v-bind:key="ind+'ad'" >
                      <div style="text-align: right;font-size: 18px;font-weight: 500;margin-bottom: 50px;">
                        <div class="print_show ">
                          <h2 class="text-center" v-show="!hideForForms">{{filters.labelType != 'TEMPERATURE' ? $t(filters.labelType) : $t('Appliance Temperature')}}</h2>
                          <h2 class="text-center mb-5" v-show="hideForForms">{{reportRows.name}}</h2>
                          <div class="float-left mt-4">
                            <h4 class="card-title">{{category.name}}</h4>
                            <h3 class="card-title">{{group.name}}</h3>
                          </div>
                          <div class="float-right mt-4">
                            <h4 v-show="startDateFormatted != null && hideForForms === false" class="card-title">{{$t("Start Date")}}: <span class="float-right pl-2">{{ startDateFormatted}}</span></h4>
                            <h4 v-show="endDateFormatted != null && hideForForms === false" class="card-title">{{$t("End Date")}}: <span class="float-right pl-2">{{ endDateFormatted}}</span></h4>
                            <h4 class="card-title"><span class="float-right pl-2">{{reportRows.date}}</span></h4>
                          </div>
                          <br><br>
                        </div>
                      </div>
                    </div>
                    <table v-bind:key="ind" class="table table-bordered">
                      <thead style="background-color: #e9f4f9;border: 2px solid #c8e9f8;">
                      <th  style="width: 250px;">Name</th>
                      <th style="width: 170px;">User</th>
                      <th style="width: 120px;">Time</th>
                      <th >Result</th>
                      </thead>
                      <tbody style="border: 2px solid #c8e9f8;">

                      <template v-for="(row, rowIndex) in reportRows.data">
                        <template v-if="row.results.length > 0">
                          <template v-for="(result,indexx) in row.results">
                            <!--<template v-if="result.order === row.order">-->
                            <tr :style="indexx === 0? '    border-top: 2px solid rgb(200, 233, 248);' : ''" v-bind:key="indexx+ind+'-'+rowIndex">
                              <th :rowspan="row.results.length"  v-bind:key="result.name+ind+indexx" v-if="indexx === 0" >{{row.name}}</th>
                              <td v-bind:key="result.userId+ind+indexx">
                                <span style="margin-right: 5px;float: left;">{{indexx+1}}</span>
                                <b-link  class="nav-link no-padding print_hide" :to="'/users/'+result.userId"> {{result.userName}} </b-link>
                                <div class="print_show">{{result.userName}}</div>
                              </td>
                              <td v-bind:key="result.recordedAt+ind+indexx">{{result.recordedAt}}</td>
                              <td v-html="result.value" v-bind:key="result.value+ind+indexx">{{result.value}}</td>
                            </tr>
                            <!--</template>-->
                            <!--<template v-else>-->
                            <!--<td v-bind:key="result" colspan="3">empty?</td>-->
                            <!--</template>-->
                          </template>
                        </template>
                        <template v-else>
                          <tr style="border-top: 2px solid rgb(200, 233, 248);" v-bind:key="rowIndex">
                            <th :colspan="row.type === 'NOTE'? 4 : 1" >{{row.name}}</th>
                            <template v-if="row.type !== 'NOTE'">
                              <td>
                              </td>
                              <td ></td>
                              <td ></td>
                            </template>

                          </tr>
                        </template>
                      </template>
                      </tbody>
                    </table>
                  </template>
                </div>
              </b-tab>
              <b-tab :title="$t('Devices')" id="sensorsTable">
                <div v-show="!showDeviceBool"  class="col-12 bg-white p-4 float-left">
                  <b-row>
                    <b-col>
                      <h4 class="pl-2">
                        {{$t('Devices')}}
                        <b-btn style="margin-left: 10px;color: white;padding-left: 12px;padding-right: 9px;" variant="light" @click="fetchSensors">{{$t('Refresh')}} <i style="padding-left: 5px;  " class="fa fa-refresh"></i></b-btn>

                      </h4>
                    </b-col>
                    <b-col>
                      <b-btn v-if="$store.state.user.data.role === 'System Admin'" style="float:right;color:white" variant="light" @click="addDeviceModal" >{{$t('Add Device')}}</b-btn>
                    </b-col>
                  </b-row>
                  <b-table
                    show-empty
                    hover
                    stacked="true"
                    :busy="devicesTableIsBusy"
                    :items="sensors"
                    :fields="deviceFields"
                    :current-page="currentSensorPage"
                    :per-page="perPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :sort-compare="customCompare"
                  >
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner variant="primary" class="align-middle"></b-spinner>
                        <strong class="text-primary" >Loading...</strong>
                      </div>
                    </template>
                    <template v-slot:cell(gatewayId)="row">
                      <b-link @click="showDevice(row.item)" >{{ row.item.gatewayId }}</b-link>
                    </template>
                    <template v-slot:cell(isActive)="row">
                      <label :class="row.item.isActive === 'true' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.isActive === "true" ? 'Active' : 'Not Active') }}</label>
                    </template>

                    <template v-slot:cell(isConnected)="row">
                      <label :class="row.item.isConnected === 'true' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.isConnected === "true" ? 'Connected' : 'Not Connected') }}</label>
                    </template>

                    <template v-slot:cell(sensorIds)="row">
                      {{ (row.item.sensorIds == "" || row.item.sensorIds == null) ? 0 :  row.item.sensorIds.split(",").length}}
                    </template>

                    <template v-slot:cell(actions)="row" >
                      <!--<b-button variant="outline-primary" size="sm" @click="mapCloneForm(row.item.id)">-->
                        <!--{{$t('Clone')}}-->
                      <!--</b-button>-->
                      <b-button v-if="$store.state.user.data.role === 'System Admin'" variant="outline-primary" size="sm" @click="addSensorModal(row.item.gatewayId)">
                        {{$t('Add Sensor')}}
                      </b-button>
                      <b-button v-if="['System Admin', 'Administrator', 'Manager'].includes($store.state.user.data.role)" variant="outline-primary" size="sm" @click="mapDeviceUpdate(row)">
                        {{$t('Edit')}}
                      </b-button>
                      <b-button v-if="$store.state.user.data.role === 'System Admin'" variant="outline-danger" size="sm" @click="deleteSensor(row.item.gatewayId, 'gateway')">
                        {{$t('Remove')}}
                      </b-button>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="currentSensorPage"
                    :total-rows="sensors.length"
                    :per-page="perPage"
                    align="center"
                    class="my-5"
                  ></b-pagination>
                </div>
                <div v-show="showDeviceBool" class="col-12 bg-white p-4 float-left">
                  <b-link class="print_hide" :append="true"
                          v-on:click="showDeviceBool= false"><i class="fa fa-chevron-left"></i>{{$t('Back to Devices') }}
                  </b-link>
                  <br>
                  <b-row class="pt-2">
                    <b-col>
                      <h4 class="pl-2">
                        {{deviceShown ? deviceShown.gatewayName : ""}} <br><br>
                        {{$t('Device Sensors')}}
                        <!--<b-btn style="margin-left: 10px;color: white;padding-left: 12px;padding-right: 9px;" variant="light" @click="fetchSensors">Refresh <i style="padding-left: 5px;  " class="fa fa-refresh"></i></b-btn>-->

                      </h4>
                    </b-col>
                    <b-col>
                      <b-btn v-if="$store.state.user.data.role === 'System Admin'" style="float:right;color:white" variant="light" @click="addSensorModal(deviceShown.gatewayId)" >{{$t('Add Sensor')}}</b-btn>
                    </b-col>
                  </b-row>

                  <b-table
                    show-empty
                    hover
                    stacked="true"
                    :busy="sensorTableIsBusy"
                    :items="deviceSensors"
                    :fields="sensorFields"
                    :current-page="currentDeviceSensorPage"
                    :per-page="perPage"
                    :sort-by.sync="sortSensorBy"
                    :sort-desc.sync="sortSensorDesc"
                    :sort-direction="sortDirection"
                    :sort-compare="customCompare"
                  >
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner variant="primary" class="align-middle"></b-spinner>
                        <strong class="text-primary" >Loading...</strong>
                      </div>
                    </template>

                    <template v-slot:cell(applianceType)="row">
                      {{$t(row.item.applianceType)}}
                    </template>

                    <template v-slot:cell(tempRange)="row">
                      {{ row.item.alertTempMin }} to {{ row.item.alertTempMax }} °C
                    </template>

                    <template v-slot:cell(isActive)="row">
                      <label :class="row.item.isActive === 'true' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.isActive === "true" ? 'Active' : 'Not Active') }}</label>
                    </template>

                    <template v-slot:cell(isConnected)="row">
                      <label :class="row.item.isConnected === 'true' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.isConnected === "true" ? 'Connected' : 'Not Connected') }}</label>
                    </template>

                    <!--<template v-slot:cell(sensorIds)="row">-->
                      <!--{{(row.item.sensorIds === "" || row.item.sensorIds === null) ? 0 : row.item.sensorIds.split(",").length }}-->
                    <!--</template>-->

                    <template v-slot:cell(actions)="row" >
                      <b-button v-if="['System Admin', 'Administrator', 'Manager'].includes($store.state.user.data.role)" variant="outline-primary" size="sm" @click="mapSensorUpdate(row)">
                        {{$t('Edit')}}
                      </b-button>
                      <b-button v-if="$store.state.user.data.role === 'System Admin'" variant="outline-danger" size="sm" @click="deleteSensor(row.item.sensorId, 'sensor')">
                        {{$t('Remove')}}
                      </b-button>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="currentDeviceSensorPage"
                    :total-rows="deviceSensors.length"
                    :per-page="perPage"
                    align="center"
                    class="my-5"
                  ></b-pagination>
                </div>
              </b-tab>
            </b-tabs>
          </b-tab>
          <b-tab :title="$t('Users')" href="#users" id="users">
            <div class="col-12 bg-white p-4 float-left">
              <b-container fluid>
              <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
                <b-spinner
                  variant="secondary"
                ></b-spinner>
              </div>
          <!-- User Interface controls -->
          <b-row>
            <b-col lg="4" class="my-1">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    :placeholder="$t('Type to Search')"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">{{$t('Clear')}}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-btn style="float:right;color:white" variant="light" @click="getCompanyUsers" v-b-modal.modal-user-to-group>{{$t('Add User to Group')}}</b-btn>
            </b-col>

          </b-row>
          <!-- Main table element -->
          <b-table
            show-empty
            hover
            stacked="true"
            :items="users"
            :fields="fields"
            :current-page="currentUserPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :sort-compare="customCompare"
            @filtered="onFiltered"
          >
            <template v-slot:empty="scope">
              <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
            </template>
            <template v-slot:cell(name)="row">
              <b-link class="nav-link no-padding" :to="'/users/'+row.item.id"> {{ row.item.firstName }} {{ row.item.lastName }} </b-link>
            </template>
            <template v-slot:cell(role)="row">
              <span v-if="row.item.role === null">{{$t('Regular User')}}</span>
              <span v-else>{{$t(row.item.role)}}</span>
            </template>
            <template v-slot:cell(status)="row">
              <label :class="row.item.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.status) }}</label>
            </template>

            <template v-slot:cell(actions)="row" >
              <b-button variant="outline-dark" size="sm" @click="removeFromGroup(row.item.id)">
                {{$t('Remove')}}
              </b-button>
            </template>
          </b-table>
          <b-pagination
            v-model="currentUserPage"
            :total-rows="users.length"
            :per-page="perPage"
            align="center"
            class="my-5"
          ></b-pagination>

        </b-container>
            </div>
          </b-tab>
        </b-tabs>
        <b-modal
      id="modal-clone-form-to-group"
      ref="modal"
      :title="$t('Clone Form to Another Group')"
      @show="resetCloneModal"
      @hidden="resetCloneModal"
      @ok="cloneFormtoGroup"
      okVariant="light"
      ok-title-html="<span style='color:white;'>Submit</span>"
      header-bg-variant="light"
      header-text-variant="white"
    >
      <form ref="form">
        <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
          <b-spinner
            variant="secondary"
          ></b-spinner>
        </div>
        <b-form-group v-if="$store.state.user.data.role === 'System Admin'" id="input-group-66" :label="$t('Select Company')" >
          <b-form-select
            size="sm"
            v-model="cloneForm.targetCompany"
            @change="fetchCompanyGroups"
            :options="cloneCompanies"
            :state="$v.cloneForm.targetGroup.$dirty ? !$v.cloneForm.targetGroup.$error : null"
          ></b-form-select>
          <b-form-invalid-feedback id="input-7-live-feedback">
            {{$t('This is a required field')}}.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="input-group-4" :label="$t('Select Group')" >
          <b-form-select
            size="sm"
            v-model="cloneForm.targetGroup"
            :options="companyGroups"
            :state="$v.cloneForm.targetGroup.$dirty ? !$v.cloneForm.targetGroup.$error : null"
          ></b-form-select>
          <b-form-invalid-feedback id="input-7-live-feedback">
            {{$t('This is a required field')}}.
          </b-form-invalid-feedback>
        </b-form-group>
      </form>
    </b-modal>
          <b-modal
          id="modal-user-to-group"
          ref="modal"
          :title="$t('Add new User to Group')"
          @show="resetModal"
          @hidden="resetModal"
          @ok="addUsertoGroup"
          okVariant="light"
          ok-title-html="<span style='color:white;'>Submit</span>"
          header-bg-variant="light"
          header-text-variant="white"
        >
          <form ref="form">
            <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
              <b-spinner
                variant="secondary"
              ></b-spinner>
            </div>
            <b-form-group id="input-group-4" :label="$t('Select User')" >
              <b-form-select
                size="sm"
                v-model="form.user"
                :options="companyUsers"
                :state="$v.form.user.$dirty ? !$v.form.user.$error : null"
              ></b-form-select>
              <b-form-invalid-feedback id="input-7-live-feedback">
                {{$t('This is a required field')}}.
              </b-form-invalid-feedback>
            </b-form-group>
          </form>
        </b-modal>
        <b-modal
          no-close-on-backdrop
      id="modal-form-to-group"
      ref="modal2"
      :title="formModalTitle"
      @hidden="resetFormModal"
      @ok="createForm"
      okVariant="light"
      ok-title-html="<span style='color:white;'>Submit</span>"
      header-bg-variant="light"
      header-text-variant="white"
      modal-class="bigger-width"
    >
      <form ref="form">
        <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
          <b-spinner
            variant="secondary"
          ></b-spinner>
        </div>
        <b-form-group id="input-group-5rr0" :label="$t('Priority')" >
          <b-form-input
                  type="number"
                  required
                  v-model="newForm.priority"
                  :state="$v.newForm.priority.$dirty ? !$v.newForm.priority.$error : null"
                  :placeholder="$t('Priority')"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            {{$t('This is a required field')}}.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="input-group-50" :label="$t('Title')" >
          <b-form-input
            v-model="newForm.name"
            :state="$v.newForm.name.$dirty ? !$v.newForm.name.$error : null"
            required
            :placeholder="$t('Title')"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            {{$t('This is a required field')}}.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="input-group-55" :label="$t('Active')" >

          <b-form-checkbox size="lg" v-model="newForm.onlyFilledFields" name="check-button" switch>
            {{ $t("Include only filled fields in reports") }}
          </b-form-checkbox>
        </b-form-group>
        <div style="width: 100%;display: inline-block;margin-bottom: 15px;">
          {{$t('Actions in form:')}} {{newForm.template.length}}
          <draggable v-model="newForm.template" group="elements" @start="drag=true" @end="drag=false" handle=".handle">
          <template v-for="(item, index) in newForm.template">
            <div style="display: inline-block;width: 100%;background-color: aliceblue;padding: 8px;" v-bind:key="index">
              <i class="fa fa-align-justify handle"></i>
              <b-form-group :style="item.type === 'NOTE' ? 'width: 60%;' : 'width: 40%;'" class="element-title"  :label="$t('Title')" >
                <b-textarea
                  style="resize: vertical"
                  v-model="item.name"
                  required
                  rows="4"
                  :placeholder="$t('Title')"
                  :state="$v.newForm.template.$each[index].name.$dirty ? !$v.newForm.template.$each[index].name.$error : null"
                ></b-textarea>
                <!--<b-form-invalid-feedback id="input-1-live-feedback">-->
                  <!--{{$t('This is a required field')}}.-->
                <!--</b-form-invalid-feedback>-->
              </b-form-group>
              <b-form-group class="element-type"  :style="item.type === 'NOTE' ? 'width: 25%;' : 'width: 35%;'" :label="$t('Type')" >
              <b-form-select
                style="font-size: 12px;"
              size="sm"
              v-model="item.type"
              :options="formTypes"
                :state="$v.newForm.template.$each[index].type.$dirty ? !$v.newForm.template.$each[index].type.$error : null"
              ></b-form-select>
                  <b-form-tags v-show="item.type === 'SINGLE_SELECTION'" placeholder="Add option" input-id="tags-basic" tag-variant="light" v-model="item.options" class="mb-2"></b-form-tags>
              </b-form-group>
              <b-form-group v-show="item.type !== 'NOTE'"  style="width: 10%;float: left;padding-left: 20px;font-size: 12px;" :label="$t('Required')" >
                <b-form-checkbox size="lg" v-model="item.required" name="check-button" switch>
                </b-form-checkbox>
              </b-form-group>

              <b-link style="color: red;float: right;line-height: 82px;text-align: center;width: 8%;" @click="newForm.template.splice(index, 1)" ><i class="fa fa-times"></i></b-link>
              <br>
            </div>
          </template>
          </draggable>
          <b-btn style="float:right;color:white" variant="light" @click="newForm.template.push({'name': null, 'type': null, required: false})" >{{$t('Add Action to Group')}}</b-btn>
        <br>
        </div>

        <b-form-group
          :label="$t('Select Users')"
          label-for="name-input"
        >
          <multiselect v-model="newForm.users" :groupSelect="true" :optionHeight="10" :showLabels="false" deselectLabel="" selectLabel="" :options="usersOptions" :multiple="true" :close-on-select="false" :searchable="false" :clear-on-select="false" group-label="groupName" group-values="users" :taggable="false" :preserve-search="false" :placeholder="$t('Select User')" label="text" track-by="value" :preselect-first="false">
          </multiselect>
        </b-form-group>
        <b-form-group id="input-group-4" :label="$t('Status')">
          <b-form-select
            size="sm"
            v-model="newForm.status"
            :options="statuses"
            required
          ></b-form-select>
        </b-form-group>
          <!--<b-form-checkbox size="lg" v-model="newForm.comments" name="check-button" switch>-->
            <!--<div> Notes </div>-->
          <!--</b-form-checkbox>-->
      </form>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      id="new-device-form"
      ref="modalDeviceModalTitle"
      :title="deviceModalTitle"
      @hidden="resetDeviceModal"
      @ok="createDevice"
      okVariant="light"
      ok-title-html="<span style='color:white;'>Submit</span>"
      header-bg-variant="light"
      header-text-variant="white"
      modal-class="bigger-width"
    >
      <form ref="form">
        <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
          <b-spinner
            variant="secondary"
          ></b-spinner>
        </div>
        <b-form-group id="input-group-40" :label="$t('Device ID')" >
          <b-form-input
            v-model="deviceForm.gatewayId"
            :state="$v.deviceForm.gatewayId.$dirty ? !$v.deviceForm.gatewayId.$error : null"
            :disabled="deviceModalTitle === 'Update Device'  ? true : false"
            required
            :placeholder="$t('Device ID')"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            {{$t('This is a required field, also must start with a G and be 13 characters long ')}}.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="input-group-40" :label="$t('Device Name')" >
          <b-form-input
            v-model="deviceForm.gatewayName"
            :state="$v.deviceForm.gatewayName.$dirty ? !$v.deviceForm.gatewayName.$error : null"
            required
            :placeholder="$t('Device Name')"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            {{$t('This is a required field')}}.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="input-group-4" :label="$t('Active')">
          <b-form-select
            size="sm"
            v-model="deviceForm.isActive"
            :options="boolStatuses"
            required
          ></b-form-select>
        </b-form-group>
        <!--<b-form-checkbox size="lg" v-model="newForm.comments" name="check-button" switch>-->
        <!--<div> Notes </div>-->
        <!--</b-form-checkbox>-->
      </form>
    </b-modal>
        <b-modal
      no-close-on-backdrop
      id="modal-sensor-form"
      ref="modalSensorModalTitle"
      :title="sensorModalTitle"
      @hidden="resetSensorModal"
      @ok="createSensor"
      okVariant="light"
      ok-title-html="<span style='color:white;'>Submit</span>"
      header-bg-variant="light"
      header-text-variant="white"
      modal-class="bigger-width"
    >
      <form ref="form">
        <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
          <b-spinner
            variant="secondary"
          ></b-spinner>
        </div>
        <b-form-group id="input-group-207" :label="$t('Sensor ID')" >
          <b-form-input
            v-model="sensorForm.sensorId"
            :state="$v.sensorForm.sensorId.$dirty ? !$v.sensorForm.sensorId.$error : null"
            required
            :disabled="sensorModalTitle === 'Update Sensor'  ? true : false"
            :placeholder="$t('Sensor ID')"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            {{$t('This is a required field, and must start with an S and be 13 characters long')}}.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="input-group-207" :label="$t('Sensor Name')" >
          <b-form-input
                  v-model="sensorForm.sensorName"
                  :state="$v.sensorForm.sensorName.$dirty ? !$v.sensorForm.sensorName.$error : null"
                  required
                  :placeholder="$t('Sensor Name')"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            {{$t('This is a required field')}}.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="input-group-4" :label="$t('Connectivity Mode')">
          <b-form-select
            size="sm"
            v-model="sensorForm.connectivityMode"
            :options="connectivityModes"
            :state="$v.sensorForm.connectivityMode.$dirty ? !$v.sensorForm.connectivityMode.$error : null"
            required
          ></b-form-select>
          <b-form-invalid-feedback id="input-1-live-feedback">
            {{$t('This is a required field')}}.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="input-group-207" :label="$t('Appliance Name')" >
          <b-form-input
            v-model="sensorForm.applianceName"
            :state="$v.sensorForm.applianceName.$dirty ? !$v.sensorForm.applianceName.$error : null"
            required
            :placeholder="$t('Appliance Name')"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            {{$t('This is a required field')}}.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="input-group-230" :label="$t('Appliance Number')" >
          <b-form-input
            type="number"
            v-model="sensorForm.applianceNumber"
            :state="$v.sensorForm.applianceNumber.$dirty ? !$v.sensorForm.applianceNumber.$error : null"
            required
            :disabled="sensorModalTitle === 'Update Sensor' ? true : false"
            :placeholder="$t('Appliance Number')"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            {{$t('This is a required field')}}.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          :label="$t('Appliance Type')"
          label-for="appliance-input"
        >
          <b-form-select
            size="sm"
            v-model="sensorForm.applianceType"
            :options="applianceTypes"
            :state="$v.sensorForm.applianceType.$dirty ? !$v.sensorForm.applianceType.$error : null"
            required
          ></b-form-select>
          <b-form-invalid-feedback id="input-1-live-feedback">
            {{$t('This is a required field')}}.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="input-group-320" :label="$t('Alert Min Temperature')" >
          <b-form-input
            type="number"
            v-model="sensorForm.alertTempMin"
            required
            :placeholder="$t('Alert Min Temperature')"
          ></b-form-input>

        </b-form-group>
        <b-form-group id="input-group-20" :label="$t('Alert Max Temperature')" >
          <b-form-input
            type="number"
            v-model="sensorForm.alertTempMax"
            required
            :placeholder="$t('Alert Max Temperature')"
          ></b-form-input>

        </b-form-group>
        <b-form-group
          :label="$t('Select Publish Time Frequency')"
          label-for="name-input"
        >
          <b-form-select
            size="sm"
            v-model="sensorForm.publishTimeout"
            :options="publishTimeoutValues"
            required
          ></b-form-select>
        </b-form-group>
        <b-form-group id="input-group-4" :label="$t('Active')">
          <b-form-select
            size="sm"
            v-model="sensorForm.isActive"
            :options="boolStatuses"
            required
          ></b-form-select>
        </b-form-group>
        <!--<b-form-checkbox size="lg" v-model="newForm.comments" name="check-button" switch>-->
        <!--<div> Notes </div>-->
        <!--</b-form-checkbox>-->
      </form>
    </b-modal>
      </div>

</template>

<script>
import moment from 'moment'
import {required, helpers} from 'vuelidate/lib/validators'
import FormResults from './OperationForms/FormResults'
const sensorIdRegex = helpers.regex('sensorIdRegex', /^S[A-Z0-9]{12,12}$/)
const gatewayIdRegex = helpers.regex('gatewayIdRegex', /^G{1,1}[0-9A-F]{12,12}$/)
export default {
  components: {FormResults},
  data () {
    return {
      tabIndex: 0,
      deviceShown: null,
      sensorTableIsBusy: false,
      currentDeviceSensorPage: 1,
      deviceSensors: [],
      showDeviceBool: false,
      sensorResults: [],
      sensorResultFieldsSortBy: 'time',
      totalSensorResultRows: 0,
      currentSensorResultPage: 1,
      sensorResultFields: [
        { key: 'deviceId', label: this.$t('Sensor Id'), sortable: true, class: 'text-left' },
        { key: 'deviceName', label: this.$t('Sensor Name'), sortable: true, class: 'text-left' },
        { key: 'applianceName', label: this.$t('Appliance Name'), sortable: true, class: 'text-left' },
        { key: 'applianceNumber', label: this.$t('Number'), sortable: true, class: 'text-left' },
        { key: 'applianceType', label: this.$t('Type'), sortable: true, class: 'text-left' },
        { key: 'temperature', label: this.$t('Temperature'), sortable: true, class: 'text-left' },
        { key: 'time', label: this.$t('Time'), sortable: true, sortDirection: 'desc', class: 'text-center' },
        { key: 'date', label: this.$t('Date'), sortable: true, class: 'text-center' }

        // { key: 'actions', label: this.$t('Actions'), class: 'text-center' }
      ],
      devicesTableIsBusy: false,
      boolStatuses: [
        {text: this.$t('Yes'), value: 'true'},
        {text: this.$t('No'), value: 'false'}
      ],
      connectivityModes: [
        {value: '', text: this.$t('Select One')},
        {value: 'WIRED', text: 'Wired'},
        {value: 'BLE', text: 'Bluetooth'}
      ],
      publishTimeoutValues: [
        {text: '5' + this.$t('minutes'), value: '5'},
        {text: '15' + this.$t('minutes'), value: '15'},
        {text: '30' + this.$t('minutes'), value: '30'},
        {text: '1' + this.$t('hour'), value: '60'},
        {text: '2' + this.$t('hours'), value: '120'},
        {text: '3' + this.$t('hours'), value: '180'},
        {text: '4' + this.$t('hours'), value: '240'},
        {text: '5' + this.$t('hours'), value: '300'},
        {text: '6' + this.$t('hours'), value: '360'}
      ],
      sensorModalTitle: 'Add Sensor',
      deviceModalTitle: 'New Device',
      sensors: [],
      currentSensorPage: 1,
      sensorBool: false,
      deviceFields: [
        { key: 'gatewayName', label: this.$t('Device Name'), sortable: true, sortDirection: 'desc', class: 'text-left' },
        { key: 'gatewayId', label: this.$t('Device ID'), sortable: true, sortDirection: 'desc', class: 'text-left' },
        { key: 'sensorIds', label: this.$t('Sensors'), sortable: false, class: 'text-center' },
        { key: 'isActive', label: this.$t('Active'), sortable: true, class: 'text-center' },
        { key: 'isConnected', label: this.$t('Connected'), sortable: true, class: 'text-center' },

        { key: 'actions', label: this.$t('Actions'), class: 'text-center' }
      ],
      sensorFields: [
        { key: 'sensorName', label: this.$t('Sensor Name'), sortable: true, sortDirection: 'desc', class: 'text-left' },
        { key: 'sensorId', label: this.$t('Sensor ID'), sortable: true, sortDirection: 'desc', class: 'text-left' },
        { key: 'applianceName', label: this.$t('Appliance Name'), sortable: true, class: 'text-center' },
        { key: 'applianceType', label: this.$t('Appliance Type'), sortable: true, class: 'text-center' },
        { key: 'applianceNumber', label: this.$t('Appliance Number'), sortable: true, class: 'text-center' },
        {
          key: 'publishTimeout',
          label: this.$t('Timeout'),
          // formatter: (value, key, item) => {
          //   return value ? 'Yes' : 'No'
          // },
          sortable: true,
          class: 'text-center'
          // sortByFormatted: true,
          // filterByFormatted: true
        },
        { key: 'tempRange', label: this.$t('Temperature Range'), sortable: false, class: 'text-center' },

        { key: 'isActive', label: this.$t('Active'), sortable: true, class: 'text-center' },
        // { key: 'isConnected', label: this.$t('Connected'), sortable: true, class: 'text-center' },

        { key: 'actions', label: this.$t('Actions'), class: 'text-center' }
      ],
      category: {},
      deviceForm: {
        id: '',
        gatewayName: '',
        gatewayId: '',
        group: '',
        company: '',
        category: '',
        isActive: 'true',
        sensorIds: []
      },
      sensorForm: {
        sensorId: '',
        sensorName: '',
        deviceId: '',
        group: '',
        connectivityMode: '',
        company: '',
        category: '',
        applianceNumber: '',
        applianceName: '',
        applianceType: null,
        publishTimeout: '30',
        isActive: 'true',
        alertTempMin: null,
        alertTempMax: null,
        isConnected: null
      },
      massReportRows: [],
      cloneCompanies: [],
      companyGroups: [],
      formResultFieldsSortBy: 'createdAt',
      haccpBool: false,
      labelsBool: false,
      cloneForm: {
        companyId: null,
        sourceGroup: null,
        targetGroup: null,
        targetCompany: null,
        formId: null
      },
      groups: [],
      selectedMonth: moment(),
      isDisable: false,
      isDisplayInput: true,
      locale: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      alignment: 'left',
      selectedBackgroundColor: 'blue',
      options: [
        {
          id: 1,
          title: 'English',
          monthLabels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        },
        {
          id: 2,
          title: 'Japanese',
          monthLabels: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        },
        {
          id: 3,
          title: 'Korean',
          monthLabels: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
        }
      ],
      alignments: ['left', 'center', 'right'],
      colorExamples: ['blue', 'red', 'black'],
      min: null,
      max: null,
      isLimitRange: false,
      clearOption: true,
      hideForForms: false,
      formsResultsView: true,
      reportName: '',
      reportDate: '',
      reportRows: [],
      formsResults: [],
      formModalTitle: this.$t('Create New Form'),
      formTypes: [
        {text: this.$t('Select Type'), value: null},
        {text: this.$t('Checkbox'), value: 'CHECKBOX'},
        {text: this.$t('Comment'), value: 'COMMENT'},
        {text: this.$t('Temperature'), value: 'TEMPERATURE'},
        {text: this.$t('Weight'), value: 'WEIGHT'},
        {text: this.$t('Option Select'), value: 'SINGLE_SELECTION'},
        {text: this.$t('Number'), value: 'NUMBER'},
        {text: this.$t('Note'), value: 'NOTE'},
        {text: this.$t('Date/Time'), value: 'DATETIME'},
        {text: this.$t('Date'), value: 'DATE'},
        {text: this.$t('Time'), value: 'TIME'},
        {text: this.$t('Barcode'), value: 'BARCODE'}
      ],
      newForm: {
        name: null,
        priority: null,
        status: 'Active',
        template: [{name: null, type: null}],
        users: [],
        onlyFilledFields: false
      },
      statuses: [{text: this.$t('Active'), value: 'Active'}, {text: this.$t('Inactive'), value: 'Inactive'}],
      forms: [],
      formsOptions: [{text: this.$t('Select User'), value: ''}],
      currentFormPage: 1,
      labelTypes: [],
      loadMoreBool: false,
      startDateFormatted: null,
      endDateFormatted: null,
      isBusy: false,
      loading: false,
      groupId: this.$route.params.id,
      group: {name: null, category: null},
      users: [],
      companyUsers: [{text: this.$t('Select User'), value: ''}],
      fields: [
        { key: 'name', label: this.$t('Name'), sortable: true, sortDirection: 'desc', class: 'text-left' },
        { key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center' },
        { key: 'role', label: this.$t('Role'), sortable: true, class: 'text-center' },
        {
          key: 'status',
          label: this.$t('Status'),
          // formatter: (value, key, item) => {
          //   return value ? 'Yes' : 'No'
          // },
          sortable: true,
          class: 'text-center'
          // sortByFormatted: true,
          // filterByFormatted: true
        },
        { key: 'actions', label: this.$t('Actions'), class: 'text-center' }
      ],
      totalRows: 1,
      currentUserPage: 1,
      currentPage: 1,
      currentFormResultPage: 1,
      totalFormResultRows: 0,
      perPage: 20,
      pageOptions: [20, 50, 100],
      includeInactive: false,
      formsSortBy: 'priority',
      sortSensorBy: 'applianceNumber',
      sortSensorDesc: false,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      form: {
        companyId: null,
        groupId: this.$route.params.id,
        user: ''
      },
      labels: [],
      selectedLabelType: null,
      usersOptions: [
        {
          groupName: this.$t('Select All'),
          users: []
        }
      ],
      sensorsOptions: [],
      sensorFilters: {
        dateRange: null,
        applianceNumber: null,
        applianceType: null
      },
      formFilters: {
        dateRange: null,
        users: [],
        form: null
      },
      monthlyFormFilters: {
        month: null,
        form: null
      },
      lastVisible: null,
      filters: {
        dateRange: null,
        users: [],
        labelType: null,
        applianceNumber: null,
        applianceType: null,
        applianceStatus: null,
        keyword: null
      },
      applianceFilter: false,
      applianceTypeFilter: false,
      applianceStatusFilter: false,
      applianceStatuses: [{text: this.$t('Select Status'), value: null}, {text: this.$t('UNDER_MAINTENANCE'), value: 'UNDER_MAINTENANCE'}, {text: this.$t('WORKING'), value: 'WORKING'}],
      applianceTypes: [{text: this.$t('Select Type'), value: null}, {text: this.$t('FREEZER'), value: 'FREEZER'}, {text: this.$t('FRIDGE'), value: 'FRIDGE'}, {text: this.$t('STORAGE'), value: 'STORAGE'}, {text: this.$t('HOT CUPBOARD'), value: 'HOTCUPBOARD'}]
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    },
    // labelTypes () {
    //   return [
    //     { value: 'LABELLING', text: this.$t('LABELLING') },
    //     { value: 'TEMPERATURE', text: this.$t('TEMPERATURE') },
    //     { value: 'BLAST_CHILLER', text: this.$t('BLAST_CHILLER') },
    //     { value: 'ALLERGEN', text: this.$t('ALLERGEN') },
    //     { value: 'INGREDIENTS', text: this.$t('INGREDIENTS') },
    //     { value: 'FREE_NOTES', text: this.$t('FREE_NOTES') },
    //     { value: 'USE_FIRST', text: this.$t('USE_FIRST') }
    //   ]
    // },
    formFields () {
      var aFields = []
      aFields.push({ key: 'priority', label: this.$t('Priority'), sortable: true })
      aFields.push({ key: 'name', label: this.$t('Title'), sortable: true })
      aFields.push({ key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center' })
      aFields.push({ key: 'updatedAtFormatted', label: this.$t('Last Update'), sortable: true, class: 'text-center' })
      aFields.push({ key: 'status', label: this.$t('Status'), sortable: true, class: 'text-center' })
      aFields.push({ key: 'actions', label: this.$t('Actions'), class: 'text-center' })
      return aFields
    },
    formResultFields () {
      var aFields = []
      aFields.push({ key: 'name', label: this.$t('Title'), sortable: true })
      aFields.push({ key: 'createdAtFormatted', label: this.$t('Created At'), sortable: true, class: 'text-center' })
      aFields.push({ key: 'actions', label: this.$t('Actions'), class: 'text-center' })
      return aFields
    },
    labelFields () {
      var self = this
      var aFields = []
      aFields.push({ key: 'userId', label: this.$t('User'), sortable: true, class: 'text-center' })
      switch (this.filters.labelType) {
        case 'LABELLING':
          aFields.push({ key: 'title', label: this.$t('Product'), sortable: true })
          aFields.push({ key: 'dateIn', label: this.$t('Prep Date'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateOut', label: this.$t('Expiry Date'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dayOut', label: this.$t('Expiry Day'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = false
          self.applianceTypeFilter = false
          self.applianceTypeFilter = false
          self.applianceStatusFilter = false
          break
        case 'QUANTITIES':
          // fields
          aFields.push({ key: 'title', label: this.$t('Title'), sortable: true })
          aFields.push({ key: 'quantity', label: this.$t('Quantity'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'quantityUnit', label: this.$t('Quantity unit'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'measurementValue', label: this.$t('Measurement value'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'measurementUnit', label: this.$t('Measurement unit'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateIn', label: this.$t('Date/Time'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = false
          self.applianceTypeFilter = false
          self.applianceTypeFilter = false
          self.applianceStatusFilter = false
          break
        case 'TEMPERATURE':
          // fields
          aFields.push({ key: 'title', label: this.$t('Appliance Title'), sortable: true })
          aFields.push({ key: 'applianceType', label: this.$t('Appliance Type'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'applianceNumber', label: this.$t('Number'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'applianceStatus', label: this.$t('Appliance Status'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'temperatureIn', label: this.$t('Temperature'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateIn', label: this.$t('Date/Time'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = true
          self.applianceTypeFilter = true
          self.applianceStatusFilter = true
          break
        case 'BLAST_CHILLER':
          aFields.push({ key: 'title', label: this.$t('Product'), sortable: true })
          aFields.push({ key: 'temperatureIn', label: this.$t('Temperature In'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'temperatureOut', label: this.$t('Temperature Out'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateIn', label: this.$t('Date/Time In'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateOut', label: this.$t('Date/Time Out'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = false
          self.applianceTypeFilter = false
          self.applianceStatusFilter = false
          break
        case 'ALLERGEN':
          aFields.push({ key: 'title', label: this.$t('Product'), sortable: true })
          aFields.push({ key: 'allergenOptions', label: this.$t('Allergen Options'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'allergenCodes', label: this.$t('Allergens'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateIn', label: this.$t('Production Date'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateOut', label: this.$t('Expiry Date'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = false
          self.applianceTypeFilter = false
          self.applianceStatusFilter = false
          break
        case 'INGREDIENTS':
          aFields.push({ key: 'title', label: this.$t('Product'), sortable: true })
          aFields.push({ key: 'ingredients', label: this.$t('Ingredients'), sortable: false })
          aFields.push({ key: 'allergenOptions', label: this.$t('Allergen Options'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'allergenCodes', label: this.$t('Allergens'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateIn', label: this.$t('Production Date'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateOut', label: this.$t('Expiry Date'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = false
          self.applianceTypeFilter = false
          self.applianceStatusFilter = false
          break
        case 'FREE_NOTES':
          aFields.push({ key: 'title', label: this.$t('Text'), sortable: true, class: 'text-left' })
          aFields.push({ key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = false
          self.applianceTypeFilter = false
          self.applianceStatusFilter = false
          break
        case 'USE_FIRST':
          aFields.push({ key: 'title', label: this.$t('Name'), sortable: true, class: 'text-left' })
          aFields.push({ key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = false
          self.applianceTypeFilter = false
          self.applianceStatusFilter = false
          break
      }
      aFields.push({ key: 'numberOfCopies', label: this.$t('Copies'), sortable: true, class: 'text-center' })
      // aFields.push({ key: 'status', label: this.$t('Status'), sortable: true })
      if (this.$store.state.user.data.role === 'System Admin') {
        // aFields.push({ key: 'actions', label: this.$t('Actions'), class: 'text-center' })
      }
      return aFields
    }
  },
  validations: {
    deviceForm: {
      gatewayName: {
        required
      },
      gatewayId: {
        required,
        gatewayIdRegex
      }
    },
    sensorForm: {
      sensorId: {
        required,
        sensorIdRegex
      },
      sensorName: {
        required
      },
      applianceName: {
        required
      },
      applianceNumber: {
        required
      },
      applianceType: {
        required
      },
      connectivityMode: {
        required
      }
    },
    cloneForm: {
      targetGroup: {
        required
      }
    },
    formFilters: {
    },
    form: {
      user: {
        required
      }
    },
    filters: {
      labelType: {
        required
      }
    },
    newForm: {
      name: {
        required
      },
      priority: {
        required
      },
      status: {
        required
      },
      template: {
        $each: {
          name: {
            required
          },
          type: {
            required
          }
        }
      }
    },
    monthlyFormFilters: {
      form: {
        required
      },
      month: {
        required
      }
    }
  },
  mounted () {
    if (this.$route.params.company) {
      this.form.companyId = this.$route.params.company
    } else {
      this.form.companyId = this.$store.state.user.data.companyId
    }

    this.fetchGroup()
    this.fetchLabelTypes()
    this.fetchSensorList()
    this.fetchSensors()
    // set default tab
    console.log('tab indessxxxxxxx')
    this.tabIndex = 0
  },
  methods: {
    switchInactive () {
      console.log('includeInactive', this.includeInactive)
      this.fetchForms()
    },
    fetchCategory () {
      let self = this

      let categoryId = this.group.hasOwnProperty('categoryId') ? this.group.categoryId : this.group.category

      this.$firebase.firestore().collection('companies').doc(this.form.companyId).collection('categories').doc(categoryId).get()
        .then(function (querySnapshot) {
          var data = querySnapshot.data()
          if (!data.hasOwnProperty('name')) {
            data.name = querySnapshot.id
          }
          data.id = querySnapshot.id
          self.category = data
        })
    },
    printExcelLabels () {
      this.$v.filters.$touch()
      if (this.$v.filters.$anyError) {
        return
      }

      if (this.filters.dateRange === null) {
        this.$swal({
          title: this.$t('Warning!'),
          text: this.$t('In order to export in excel you need to select a specific date range'),
          type: 'info',
          timer: 0,
          showConfirmButton: true
        })
        return
      }
      var data = {}
      data.groupId = this.$route.params.id
      if (this.$route.params.company != null) {
        data.companyId = this.$route.params.company
      } else {
        data.companyId = this.$store.state.user.data.companyId
      }
      data.labelType = this.filters.labelType
      data.filters = JSON.stringify(this.filters)
      console.log('dataaa', data)
      window.open(this.$firebase.app().options.functionsHostName + '/labelsExport?' + new URLSearchParams(data))
    },
    printSensorLogs () {
      var data = {}

      data.groupId = this.$route.params.id
      if (this.$route.params.company != null) {
        data.companyId = this.$route.params.company
      } else {
        data.companyId = this.$store.state.user.data.companyId
      }

      var applianceNumbersSelected = []
      console.log('this.sensorFilters', this.sensorFilters)
      if (this.sensorFilters.applianceNumber) {
        this.sensorFilters.applianceNumber.forEach(applNo => {
          applianceNumbersSelected.push(applNo.value)
        })
      }

      data.filters = JSON.parse(JSON.stringify(this.sensorFilters))

      data.filters.applianceNumber = applianceNumbersSelected

      data.filters = JSON.stringify(data.filters)

      window.open(this.$firebase.app().options.functionsHostName + '/downloadSensorLogsReport?' + new URLSearchParams(data))
      // window.open('http://localhost:5002/memo-chef-dev/us-central1/downloadSensorLogsReport/downloadSensorLogsReport?' + new URLSearchParams(data))

      // var sortedData = this.sensorResults.sort(function (a, b) {
      //   return a - b
      // })
      //
      // sortedData = sortedData.sort(function (a, b) {
      //   if (a.applianceNumber === b.applianceNumber) {
      //     console.log('b.timestamp', b.timestamp)
      //     return (b.timestamp.toDate() - a.timestamp.toDate())
      //   } else if (a.applianceNumber > b.applianceNumber) {
      //     return 1
      //   } else if (a.applianceNumber < b.applianceNumber) {
      //     return -1
      //   }
      // })

      // var sortedData = this.sensorResults.sort((a, b) => a.applianceNumber - b.applianceNumber || b.timestamp.toDate() - a.timestamp.toDate())
      //
      // var arrayData = []
      // sortedData.forEach(data => {
      //   arrayData.push(JSON.stringify(data))
      // })
      //
      // var fieldsData = []
      // this.sensorResultFields.forEach(data => {
      //   fieldsData.push(JSON.stringify(data))
      // })
      // var name = null
      // if (this.sensorFilters.applianceNumber != null) {
      //   this.sensorsOptions.forEach(data => {
      //     let selectedVal = data.sensors.find(t => t.value === this.sensorFilters.applianceNumber)
      //
      //     if (selectedVal) {
      //       name = selectedVal.text
      //     }
      //   })
      // }
      //
      // var query = {
      //   data: arrayData,
      //   fields: fieldsData,
      //   name: name,
      //   category: this.group.category,
      //   group: this.group.name,
      //   startDateFormatted: '',
      //   endDateFormatted: ''
      // }
      //
      // if (this.sensorFilters.dateRange != null) {
      //   query.startDateFormatted = moment(new Date(this.sensorFilters.dateRange.start).toString()).format('DD/MM/YYYY kk:mm')
      //   query.endDateFormatted = moment(new Date(this.sensorFilters.dateRange.end).toString()).format('DD/MM/YYYY kk:mm')
      // }
      //
      // let routeData = this.$router.resolve({name: 'PrintPreview', query: query})

      // window.open(routeData.href, '_blank')
    },
    createSensor (e) {
      e.preventDefault()
      let self = this
      this.$v.sensorForm.$touch()
      if (this.$v.sensorForm.$anyError) {
        return
      }
      if (this.sensorForm.alertTempMax !== null && this.sensorForm.alertTempMin !== null && (parseFloat(this.sensorForm.alertTempMax) <= parseFloat(this.sensorForm.alertTempMin))) {
        self.$swal({
          title: self.$t('There was an error!'),
          text: 'Alert Min Temperature must smaller than Alert Max Temperature',
          type: 'error',
          timer: 0,
          showConfirmButton: true
        })
        return
      }
      this.loading = true

      var data = {}
      data.gatewayId = this.sensorForm.gatewayId
      data.sensorId = this.sensorForm.sensorId
      data.sensorName = this.sensorForm.sensorName
      data.alertTempMax = this.sensorForm.alertTempMax
      data.alertTempMin = this.sensorForm.alertTempMin
      data.alertSuspendTime = '30'
      data.applianceType = this.sensorForm.applianceType
      data.applianceName = this.sensorForm.applianceName
      data.applianceNumber = this.sensorForm.applianceNumber
      // data.group = this.$route.params.id
      // data.category = this.group.categoryId
      data.isActive = this.sensorForm.isActive.toString()
      data.publishTimeout = this.sensorForm.publishTimeout
      data.sensorType = 'temperature'
      data.connectivityMode = this.sensorForm.connectivityMode
      // if (this.$route.params.company != null) {
      //   data.company = this.$route.params.company
      // } else {
      //   data.company = this.$store.state.user.data.companyId
      // }

      console.log(data)

      const sensorFun = this.$firebase.functions().httpsCallable(this.sensorAction)
      sensorFun(data).then(function (result) {
        // success or error handling

        if (result) {
          self.$swal({
            title: self.$t('Successful submission!'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(function (result) {
            console.log(result)

            if (self.deviceShown !== null) {
              self.fetchDeviceSensors(self.deviceShown.gatewayId)
            } else {
              self.fetchSensors()
            }

            self.$v.$reset()
            self.$refs.modalSensorModalTitle.hide()
          })
        } else {
          self.$swal({
            title: self.$t('There was an error!'),
            text: '',
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        }
        self.loading = false
      })
        .catch(err => {
          // An error occurred
          console.log(err)
          self.$swal({
            title: self.$t('There was an Error!'),
            text: err['message'],
            type: 'error',
            timer: 0,
            showConfirmButton: true
          }).then(function (result) {
            self.loading = false
          })
        })
    },
    createDevice (e) {
      e.preventDefault()

      this.$v.deviceForm.$touch()
      if (this.$v.deviceForm.$anyError) {
        return
      }
      this.loading = true
      let self = this

      var data = {}
      data.gatewayId = this.deviceForm.gatewayId
      data.gatewayName = this.deviceForm.gatewayName
      data.group = this.$route.params.id
      data.category = this.group.categoryId
      data.isActive = this.deviceForm.isActive.toString()
      // data.publishTimeout = this.sensorForm.publishTimeout
      if (this.$route.params.company != null) {
        data.company = this.$route.params.company
      } else {
        data.company = this.$store.state.user.data.companyId
      }
      console.log('sensoorororrorr====', data)
      // return

      const sensorFun = this.$firebase.functions().httpsCallable(this.deviceAction)
      sensorFun(data).then(function (result) {
        // success or error handling

        if (result) {
          self.$swal({
            title: self.$t('Successful submission!'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(function (result) {
            console.log(result)
            self.fetchSensors()
            self.$v.$reset()
            self.$refs.modalDeviceModalTitle.hide()
          })
        } else {
          self.$swal({
            title: self.$t('There was an error!'),
            text: '',
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        }
        self.loading = false
      })
        .catch(err => {
          // An error occurred
          console.log(err)
          self.$swal({
            title: self.$t('There was an Error!'),
            text: err['message'],
            type: 'error',
            timer: 0,
            showConfirmButton: true
          }).then(function (result) {
            self.loading = false
          })
        })
    },
    mapDeviceUpdate (row) {
      var self = this

      this.deviceForm = JSON.parse(JSON.stringify(row.item))
      console.log('sensor', self.newForm)
      this.deviceModalTitle = this.$t('Update Device')
      this.deviceAction = 'updateGateway'
      this.$bvModal.show('new-device-form')
    },
    mapSensorUpdate (row) {
      var self = this

      this.sensorForm = JSON.parse(JSON.stringify(row.item))
      console.log('sensor', self.newForm)
      this.sensorModalTitle = this.$t('Update Sensor')
      this.sensorAction = 'updateSensor'
      this.$bvModal.show('modal-sensor-form')
    },
    deleteSensor (id, type) {
      var self = this
      this.$bvModal.msgBoxConfirm(self.$t('You are about to delete this Sensor. This action cannot be undone.'),
        {
          title: self.$t('Are you sure?'),
          okVariant: 'danger',
          okTitle: 'Confirm',
          centered: true
        })
        .then(value => {
          self.loading = true
          if (value) {
            const removeDevice = this.$firebase.functions().httpsCallable('deleteDevice')

            removeDevice({'deviceId': id}).then(function (result) {
              // success or error handling
              console.log('result', result)
              if (result) {
                if (type === 'sensor') {
                  self.fetchDeviceSensors(self.deviceShown.gatewayId)
                } else {
                  self.fetchSensors()
                }
                self.$swal({
                  title: self.$t('Deleted!'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false
                })
              } else {
                self.$swal({
                  title: self.$t('There was an error!'),
                  text: '',
                  type: 'error',
                  timer: 0,
                  showConfirmButton: false
                })
              }
              self.loading = false
            })
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err)
          self.loading = false
        })
    },
    groupByKey (array, key) {
      return array
        .reduce((hash, obj) => {
          if (obj[key] === undefined) return hash
          return Object.assign(hash, {[obj[key]]: (hash[obj[key]] || []).concat(obj)})
        }, {})
    },
    fetchSensorList () {
      var self = this
      let params = {
        'group': this.$route.params.id,
        'company': '',
        'category': this.group.categoryId ? this.group.categoryId : '',
        'gatewayId': ''
      }
      if (this.$route.params.company != null) {
        params.company = this.$route.params.company
      } else {
        params.company = this.$store.state.user.data.companyId
      }
      const getDevices = this.$firebase.functions().httpsCallable('getSensorList')
      getDevices(params).then(function (result) {
        if (!result.hasOwnProperty('data')) {
          console.log('error')
        }
        console.log('sensorsList', result.data)
        // self.sensorsOptions = [{text: self.$t('Select Sensor'), value: null}]

        self.sensorsOptions = []

        var grouped = self.groupByKey(result.data, 'gatewayId')

        for (var key in grouped) {
          if (grouped.hasOwnProperty(key)) {
            var aSensors = []
            result.data.forEach(function (device) {
              if (device.gatewayId === key) {
                aSensors.push({
                  value: device.applianceNumber,
                  text: device.applianceName + ' ' + device.applianceNumber
                })
              }
            })
            self.sensorsOptions.push({gatewayName: grouped[key][0].gatewayName, sensors: aSensors})
          }
        }
        console.log(self.sensorsOptions)
        // remove dups
        // arr = arr.filter (function (value, index, array) {
        //   return array.indexOf (value) == index;
        // });
      })
    },
    fetchSensors () {
      console.log('fetching')
      var self = this

      this.devicesTableIsBusy = true
      let params = {
        'group': this.$route.params.id,
        'company': '',
        'category': this.group.categoryId ? this.group.categoryId : ''
      }

      if (this.$route.params.company != null) {
        params.company = this.$route.params.company
      } else {
        params.company = this.$store.state.user.data.companyId
      }

      console.log(params)
      const getDevices = this.$firebase.functions().httpsCallable('getGatewayList')

      getDevices(params).then(function (result) {
        // success or error handling
        console.log('result', result)
        if (!result.hasOwnProperty('data')) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.sensors = result.data
        }
        self.devicesTableIsBusy = false
        self.loading = false
      }).catch(function (err) {
        console.log('Failed to fetch Gateway', err)
      })
    },
    customCompare (a, b, key) {
      if (['date', 'time', 'dateIn', 'dateOut', 'createdAt', 'createdAtFormatted', 'updatedAtFormatted'].includes(key)) {
        var aDate = moment(a[key], 'DD/MM/YYYY kk:mm')
        var bDate = moment(b[key], 'DD/MM/YYYY kk:mm')
        if (aDate.isValid && bDate.isValid) {
          if (aDate < bDate) {
            return -1
          } else if (aDate > bDate) {
            return 1
          } else {
            return 0
          }
        }
        return null
      } else {
        // Let b-table handle sorting other fields (other than `date` field)
        return false
      }
    },
    cloneFormtoGroup (e) {
      e.preventDefault()
      this.$v.cloneForm.$touch()
      if (this.$v.cloneForm.$anyError) {
        return
      }
      this.loading = true
      let self = this

      const cloneForm = this.$firebase.functions().httpsCallable('cloneFormToGroup')
      cloneForm(this.cloneForm).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$swal({
            title: self.$t('Form Cloned to Group!'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    mapCloneForm (formId) {
      let self = this
      this.fetchCompanyGroups()

      self.cloneCompanies = []
      this.$store.state.companies.forEach(function (company) {
        self.cloneCompanies.push({value: company.id, text: company.name})
      })

      this.cloneForm.formId = formId
      this.cloneForm.companyId = this.form.companyId
      this.cloneForm.sourceGroup = this.$route.params.id
      this.$bvModal.show('modal-clone-form-to-group')
    },
    async fetchCompanyGroups () {
      let self = this
      self.companyGroups = []
      switch (self.$store.state.user.data.role) {
        case 'System Admin':
          console.log('company to search::', this.cloneForm.targetCompany)
          if (this.cloneForm.targetCompany != null) {
            this.$firebase.firestore().collection('companies').doc(this.cloneForm.targetCompany).collection('groups').orderBy('name', 'asc').get().then(function (groups) {
              self.groups = [{text: self.$t('Select Group'), value: ''}]
              groups.forEach(function (group) {
                // console.log('user', user.data().firstName)
                let groupData = group.data()
                if (!self.companyGroups.includes(group.id) && group.id !== self.$route.params.id) {
                  self.companyGroups.push({value: group.id, text: groupData.category + ' - ' + groupData.name})
                  self.companyGroups.sort((a, b) => a.text - b.text)
                }
              })
            })
          }
          break
        case 'Administrator':
          this.$firebase.firestore().collection('companies').doc(this.form.companyId).collection('groups').get().then(function (groups) {
            self.groups = [{text: self.$t('Select Group'), value: ''}]
            groups.forEach(function (group) {
              // console.log('user', user.data().firstName)
              let groupData = group.data()
              if (!self.companyGroups.includes(group.id) && group.id !== self.$route.params.id) {
                self.companyGroups.push({value: group.id, text: groupData.category + ' - ' + groupData.name})
              }
            })
          })
          break
        case 'Manager':
          let objectToMatch = {
            managerId: self.$store.state.user.data.uid,
            managerName: self.$store.state.user.data.firstName + ' ' + self.$store.state.user.data.lastName
          }
          var categoryList = []
          await this.$firebase.firestore().collection('companies').doc(this.form.companyId).collection('categories')
            .where('managers', 'array-contains', objectToMatch).get().then(function (categories) {
              categories.forEach(function (category) {
                categoryList.push(category.id)
              })
            })
          this.$firebase.firestore().collection('companies').doc(this.form.companyId).collection('groups').where('categoryId', 'in', categoryList).get().then(function (groups) {
            self.groups = [{text: self.$t('Select Group'), value: ''}]
            groups.forEach(function (group) {
              // console.log('user', user.data().firstName)
              let groupData = group.data()
              if (!self.companyGroups.includes(group.id) && group.id !== self.$route.params.id) {
                self.companyGroups.push({value: group.id, text: groupData.category + ' - ' + groupData.name})
              }
            })
          })
          break
      }
    },
    handleSelect (value) {
      console.log('Select', value)
    },
    setSelectRange (min, max) {
      this.min = min
      this.max = max
    },
    mapFormUpdate (form) {
      var self = this
      var formUsers = []
      form.item.users.forEach(function (userId) {
        // console.log('dasdaasda id ', userId)
        // console.log('company userssssss', self.Group Forms[0].users)
        var index = self.usersOptions[0].users.findIndex(u => u.value === userId)
        // console.log('indexxxx', index)
        if (index !== -1) {
          formUsers.push(self.usersOptions[0].users[index])
        }
      })
      this.newForm = JSON.parse(JSON.stringify(form.item))
      this.newForm.users = formUsers
      console.log('formmmmmm', self.newForm)
      this.formModalTitle = this.$t('Update Form')
      this.$bvModal.show('modal-form-to-group')
    },
    prePrint (item) {
      this.showReport(item, false)
      this.printFormResults()
      this.hideForForms = true
      var self = this
      setTimeout(function () {
        // self.reportRows = []
        self.formsResultsView = true
      }, 2000)
    },
    prePrintAll () {
      var self = this
      this.hideForForms = true
      console.log('formsResults', this.formsResults)
      this.massReportRows = []
      this.formsResults.forEach(function (item) {
        console.log('item', item)
        self.showReport(item, true)
      })

      this.printFormResults()
      setTimeout(function () {
        // self.reportRows = []
        self.formsResultsView = true
      }, 2000)
    },
    showReport (item, mass) {
      // construct array
      var self = this
      var reportRows = []
      console.log('itemmmmmm=====', item)
      this.reportName = item.name
      this.reportDate = moment(String(item.createdAt.toDate())).format('dddd DD/MM/YYYY')
      // var sorted = item.results.sort(self.compare)
      for (var i = 0; i < item.template.length; i++) {
        // console.log('indexxxxxxxx', i)
        var index = item.template.findIndex(v => v.order === i + 1)
        if (index !== -1) {
          var element = item.template[index]
          // debugger
          element['results'] = []
          element['date'] = moment(String(item.createdAt.toDate())).format('dddd DD/MM/YYYY')
          // var submissionId = null
          // console.log(item)
          item.results.forEach(function (result) {
            var resultObj = {...result}
            // console.log('result', result)
            // console.log('resultObj', resultObj)
            // if (submissionId === result.submissionId || submissionId == null)
            // console.log('checksss======', result.order + '===' + element.order)
            if (resultObj.order === element.order) {
              console.log('in with', resultObj)
              switch (resultObj.type) {
                case 'TEMPERATURE':
                  resultObj.value = resultObj.value + ' ℃'
                  break
                case 'CHECKBOX':
                  resultObj.value = resultObj.value === true ? '<i class="fa fa-check"></i>' : '<i class="fa fa-times"></i>'
                  break
                case 'WEIGHT':
                  resultObj.value = resultObj.value + ' kg'
                  break
                default:
                  resultObj.value = resultObj.hasOwnProperty('value') ? resultObj.value : ''
                  break
              }
              resultObj.recordedAt = moment(String(resultObj.recordedAt.toDate())).format('DD/MM HH:mm')
              // console.log('recorded', result.recordedAt)
              // console.log('recorded String =  = = =', result.recordedAt.toString())

              // console.log('companyUserss===', self.users)
              var user = self.users.find(u => u.id === resultObj.userId)
              if (user) {
                resultObj.userName = user.firstName + ' ' + user.lastName
              }
              element['results'].push(resultObj)
            }
          })
          reportRows.push(element)
        }
      }
      var objectReportRows = {}
      console.log('created at', moment(String(item.createdAt.toDate())).format('dddd DD/MM/YYYY'))
      objectReportRows['date'] = moment(String(item.createdAt.toDate())).format('dddd DD/MM/YYYY')
      objectReportRows['name'] = item.name
      objectReportRows['data'] = reportRows

      if (mass) {
        this.massReportRows.push(objectReportRows)
      } else {
        this.massReportRows = []
        this.massReportRows.push(objectReportRows)
      }

      console.log('this.objectReportRows', objectReportRows)
      this.formsResultsView = false
    },
    fetchForms () {
      var self = this
      this.formsOptions = [{text: this.$t('Select Form'), value: null}]
      let statuses = ['Active']
      if (this.includeInactive) {
        statuses.push('Inactive')
      }
      this.$firebase.firestore().collection('companies').doc(this.form.companyId).collection('groups')
        .doc(this.$route.params.id)
        .collection('forms')
        .where('status', 'in', statuses).orderBy('priority', 'asc').get().then(function (forms) {
          self.forms = []
          console.log('forms', forms)
          forms.forEach(function (form) {
            console.log('form', form.data())
            var formData = form.data()
            formData.id = form.id
            if (formData.createdAt != null) {
              formData.createdAt = moment(String(formData.createdAt.toDate())).format('DD/MM/YYYY hh:mm')
            }
            if (formData.updatedAt != null) {
              formData.updatedAtFormatted = moment(String(formData.updatedAt.toDate())).format('DD/MM/YYYY kk:mm')
            }
            self.forms.push(formData)
            self.formsOptions.push({value: form.id, text: formData.name})
          })
        })
    },
    createForm (e) {
      e.preventDefault()

      this.$v.newForm.$touch()
      if (this.$v.newForm.$anyError) {
        return
      }
      this.loading = true
      let self = this
      var aUsers = []
      this.newForm.users.forEach(user => {
        aUsers.push(user.value)
      })
      console.log('aUsers', aUsers)
      var data = {}
      data.form = this.newForm
      data.form.users = aUsers
      data.groupId = this.$route.params.id
      if (this.$route.params.company != null) {
        data.companyId = this.$route.params.company
      } else {
        data.companyId = this.$store.state.user.data.companyId
      }
      this.newForm.template.forEach((element, index) => {
        element['order'] = index + 1
      })
      // console.log('datatatatattatatata====', data)
      // return
      const addUser = this.$firebase.functions().httpsCallable('createForm')
      addUser(data).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$swal({
            title: self.$t('Successful submission!'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(function (result) {
            console.log(result)
            self.fetchForms()
            self.$refs.modal2.hide()
          })
        }
        self.loading = false
      })
    },
    fetchLabelTypes () {
      var self = this
      let labels = [
        { value: 'LABELLING', text: self.$t('LABELLING') },
        { value: 'TEMPERATURE', text: self.$t('TEMPERATURE') },
        { value: 'QUANTITIES', text: self.$t('QUANTITIES') },
        { value: 'BLAST_CHILLER', text: self.$t('BLAST_CHILLER') },
        { value: 'ALLERGEN', text: self.$t('ALLERGEN') },
        { value: 'INGREDIENTS', text: self.$t('INGREDIENTS') },
        { value: 'FREE_NOTES', text: self.$t('FREE_NOTES') },
        { value: 'USE_FIRST', text: self.$t('USE_FIRST') }]

      this.$firebase.firestore().doc('companies/' + this.form.companyId + '/settings/preferences').get().then(function (doc) {
        var preferences = doc.data()
        if (preferences) {
          if (preferences.hasOwnProperty('labelTypes')) {
            if (preferences.labelTypes.findIndex(t => t === 'FORMS') !== -1) {
              self.haccpBool = true
            }
            if (preferences.labelTypes.findIndex(t => t === 'DEVICES') !== -1) {
              self.sensorBool = true
            }
            if (
              (preferences.labelTypes.findIndex(t => t === 'LABELLING') !== -1) ||
              (preferences.labelTypes.findIndex(t => t === 'TEMPERATURE') !== -1) ||
              (preferences.labelTypes.findIndex(t => t === 'BLAST_CHILLER') !== -1) ||
              (preferences.labelTypes.findIndex(t => t === 'ALLERGEN') !== -1) ||
              (preferences.labelTypes.findIndex(t => t === 'INGREDIENTS') !== -1) ||
              (preferences.labelTypes.findIndex(t => t === 'FREE_NOTES') !== -1) ||
              (preferences.labelTypes.findIndex(t => t === 'USE_FIRST') !== -1) ||
              (preferences.labelTypes.findIndex(t => t === 'QUANTITIES') !== -1)
            ) {
              self.labelsBool = true
            }

            labels.forEach(type => {
              // console.log('type', type)
              var index = preferences.labelTypes.findIndex(t => t === type.value)
              // console.log('index', index)
              if (index !== -1) {
                var lType = preferences.labelTypes[index]
                self.labelTypes.push({value: lType, text: self.$t(lType)})
              }
            })
            //
            // preferences.labelTypes.forEach(type => {
            //   self.labelTypes.push({value: type, text: self.$t(type)})
            // })
          }
        } else {
          self.labelTypes = labels
        }
      })
    },
    clearResults () {
      this.filters.applianceType = null
      this.filters.applianceStatus = null
      this.filters.applianceNumber = null
      this.labels = []
    },
    searchLabels (clear) {
      var self = this
      var data = {}

      this.$v.filters.$touch()
      if (this.$v.filters.$anyError) {
        return
      }

      this.loadMoreBool = true
      if (clear) {
        this.labels = []
        this.lastVisible = null
      }
      if (this.lastVisible) {
        data.lastVisible = this.lastVisible
      }

      // for printing purposes
      if (this.filters.dateRange != null) {
        this.startDateFormatted = moment(new Date(this.filters.dateRange.start).toString()).format('DD/MM/YYYY')
      } else {
        this.startDateFormatted = null
      }
      if (this.filters.dateRange != null) {
        this.endDateFormatted = moment(new Date(this.filters.dateRange.end).toString()).format('DD/MM/YYYY')
      } else {
        this.endDateFormatted = null
      }

      data.groupId = this.$route.params.id
      if (this.$route.params.company != null) {
        data.companyId = this.$route.params.company
      } else {
        data.companyId = this.$store.state.user.data.companyId
      }
      data.filters = this.filters
      this.$store.dispatch('searchLabels', data).then(resp => {
        if (resp.lastVisible != null) {
          self.lastVisible = resp.lastVisible
        }
        resp.labels.forEach(label => {
          var user = self.users.find(u => u.id === label.userId)
          if (user) {
            label.userName = user.firstName + ' ' + user.lastName
          }
          self.labels.push(label)
        })
      })
    },
    loadMore () {
      this.searchLabels(false)
    },
    fetchSensorLogs (clear) {
      this.currentSensorResultPage = 1
      console.log(clear)
      var self = this
      // this.$firebase.firestore().collection('companies').doc(this.form.companyId).collection('groups').doc(self.$route.params.id).collection('temperatureLogs').where('deviceId', '==', self.sensorFilters.device).get().then(function (logs) {
      //   logs.forEach(function (log) {
      //     var logData = log.data()
      //     logData['timestamp'] = moment(String(logData['timestamp'].toDate())).format('DD/MM/YYYY kk:mm')
      //     self.sensorResults.push(logData)
      //   })
      // })

      var data = {}

      if (clear) {
        this.sensorResults = []
      }

      // for printing purposes
      if (this.sensorFilters.dateRange != null) {
        this.startDateFormatted = moment(new Date(this.sensorFilters.dateRange.start).toString()).format('DD/MM/YYYY')
      } else {
        this.startDateFormatted = null
      }
      if (this.sensorFilters.dateRange != null) {
        this.endDateFormatted = moment(new Date(this.sensorFilters.dateRange.end).toString()).format('DD/MM/YYYY')
      } else {
        this.endDateFormatted = null
      }

      data.groupId = this.$route.params.id
      if (this.$route.params.company != null) {
        data.companyId = this.$route.params.company
      } else {
        data.companyId = this.$store.state.user.data.companyId
      }

      var applianceNumbersSelected = []
      console.log('this.sensorFilters', this.sensorFilters)
      if (this.sensorFilters.applianceNumber) {
        this.sensorFilters.applianceNumber.forEach(applNo => {
          applianceNumbersSelected.push(applNo.value)
        })
      }
      data.filters = JSON.parse(JSON.stringify(this.sensorFilters))

      data.filters.applianceNumber = applianceNumbersSelected

      this.$store.dispatch('searchTemperatureLogs', data).then(resp => {
        console.log(resp.sensors)
        self.sensorResults = resp.sensors
        self.totalSensorResultRows = resp.sensors.length
      })
    },
    searchForms (clear) {
      var self = this
      var data = {}

      this.$v.formFilters.$touch()
      if (this.$v.formFilters.$anyError) {
        return
      }

      this.loadMoreBool = true
      if (clear) {
        this.formsResults = []
      }

      // for printing purposes
      if (this.formFilters.dateRange != null) {
        this.startDateFormatted = moment(new Date(this.formFilters.dateRange.start).toString()).format('DD/MM/YYYY')
      } else {
        this.startDateFormatted = null
      }
      if (this.formFilters.dateRange != null) {
        this.endDateFormatted = moment(new Date(this.formFilters.dateRange.end).toString()).format('DD/MM/YYYY')
      } else {
        this.endDateFormatted = null
      }

      data.groupId = this.$route.params.id
      if (this.$route.params.company != null) {
        data.companyId = this.$route.params.company
      } else {
        data.companyId = this.$store.state.user.data.companyId
      }
      data.filters = this.formFilters
      this.$store.dispatch('searchForms', data).then(resp => {
        console.log(resp.forms)
        // resp.forms.forEach(form => {
        //   var user = self.users.find(u => u.id === form.userId)
        //   if (user) {
        //     form.userName = user.firstName + ' ' + user.lastName
        //   }
        //   self.labels.push(label)
        // })
        self.formsResults = resp.forms
        self.totalFormResultRows = resp.forms.length
      })
    },
    deleteForm (formId) {
      let self = this
      this.$bvModal.msgBoxConfirm(self.$t('You are about to remove this Form from the Group.'),
        {
          title: self.$t('Are you sure?'),
          okVariant: 'danger',
          okTitle: self.$t('Confirm'),
          centered: true
        })
        .then(value => {
          if (value) {
            this.loading = true
            var data = {
              formId: formId,
              companyId: self.$route.params.hasOwnProperty('company') ? self.$route.params.company : self.$store.state.user.data.companyId,
              groupId: self.$route.params.id
            }
            const removeFormFromGroup = this.$firebase.functions().httpsCallable('removeFormFromGroup')
            removeFormFromGroup(data).then(function (result) {
              // success or error handling
              if (result.data.errorInfo) {
                self.$swal({
                  title: self.$t('There was an error!'),
                  text: result.data.errorInfo.message,
                  type: 'error',
                  timer: 1000,
                  showConfirmButton: false
                })
              } else {
                self.$swal({
                  title: self.$t('Form Removed from Group!'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false
                }).then(function (result) {
                  let index = self.users.findIndex(u => u.id === formId)
                  if (index > -1) {
                    self.users.splice(index, 1)
                  }
                  self.fetchForms()
                  self.$refs.modal.hide()
                })
              }
              self.loading = false
            })
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
    },
    removeFromGroup (userId) {
      let self = this
      this.$bvModal.msgBoxConfirm(self.$t('You are about to remove this User from the Group.'),
        {
          title: self.$t('Are you sure?'),
          okVariant: 'danger',
          okTitle: self.$t('Confirm'),
          centered: true
        })
        .then(value => {
          if (value) {
            this.loading = true
            var data = {
              userId: userId,
              companyId: self.$route.params.hasOwnProperty('company') ? self.$route.params.company : self.$store.state.user.data.companyId,
              groupId: self.$route.params.id
            }
            const removeUserFromGroup = this.$firebase.functions().httpsCallable('removeUserFromGroup')
            removeUserFromGroup(data).then(function (result) {
              // success or error handling
              if (result.data.errorInfo) {
                self.$swal({
                  title: self.$t('There was an error!'),
                  text: result.data.errorInfo.message,
                  type: 'error',
                  timer: 0,
                  showConfirmButton: true
                })
              } else {
                self.$swal({
                  title: self.$t('User Removed from Group!'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false
                }).then(function (result) {
                  let index = self.users.findIndex(u => u.id === userId)
                  if (index > -1) {
                    self.users.splice(index, 1)
                  }
                  self.fetchGroup(true)
                  self.$refs.modal.hide()
                })
              }
              self.loading = false
            })
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
    },
    createFormModal () {
      var self = this
      self.formModalTitle = this.$t('Create New Form')
      this.$bvModal.show('modal-form-to-group')
    },
    addSensorModal (deviceId) {
      var self = this
      self.sensorModalTitle = this.$t('Add New Sensor')
      this.sensorAction = 'addSensor'
      this.sensorForm.gatewayId = deviceId
      this.$bvModal.show('modal-sensor-form')
    },
    addDeviceModal () {
      var self = this
      self.deviceModalTitle = this.$t('Add New Device')
      this.deviceAction = 'addGateway'
      this.$bvModal.show('new-device-form')
    },
    fetchGroups () {
      var self = this
      this.$firebase.firestore().collection('companies').doc(this.form.companyId).collection('groups').where('category', '==', self.group.categoryId).get().then(function (groups) {
        self.groups = [{text: self.$t('Select Group'), value: ''}]
        groups.forEach(function (group) {
          // console.log('user', user.data().firstName)
          var groupData = group.data()
          if (!self.groups.includes(group.id) && group.id !== self.$route.params.id) {
            self.groups.push({value: group.id, text: groupData.name})
          }
        })
      })
    },
    getCompanyUsers () {
      var self = this
      this.$firebase.firestore().collection('users')
        .where('companyId', '==', this.form.companyId)
        .orderBy('firstName').get().then(function (users) {
          self.companyUsers = [{text: self.$t('Select User'), value: ''}]

          users.forEach(function (user) {
            console.log('self.users', self.users.findIndex(x => x.id === user.id))
            var userData = user.data()
            if (self.users.findIndex(x => x.id === user.id) === -1) {
              var name = userData.firstName + ' ' + userData.lastName
              self.companyUsers.push({value: user.id, text: self.$t(userData.role == null ? 'User' : userData.role) + ' - ' + name})
            }
          })
        })
    },
    fetchGroup (bypass = false) {
      let self = this
      if (self.group.name === null || bypass) {
        var group = this.$firebase.firestore().collection('companies').doc(this.form.companyId).collection('groups').doc(this.$route.params.id)
        group.get().then(function (querySnapshot) {
          var groupData = querySnapshot.data()
          self.group = groupData
          self.group['id'] = querySnapshot.id

          if (!self.group.hasOwnProperty('categoryId')) {
            self.group['categoryId'] = groupData.category
          }

          self.usersOptions[0].users = []
          self.users = []
          groupData.users.forEach(function (userId) {
            self.$firebase.firestore().collection('users').doc(userId).get().then(function (user) {
              var userData = user.data()
              userData.id = user.id

              // preare user select options
              self.usersOptions[0].users.push({text: userData.firstName + ' ' + userData.lastName, value: user.id})

              if (userData.createdAt != null) {
                userData.createdAt = moment(String(userData.createdAt.toDate())).format('DD/MM/YYYY')
              }
              self.users.push(userData)
            })
          })
          self.fetchCategory()
        })
      }
    },
    resetDeviceModal () {
      this.deviceForm =
        {
          id: '',
          gatewayId: '',
          group: '',
          company: '',
          category: '',
          isActive: 'true',
          sensorIds: []
        }
      this.$v.$reset()
    },
    resetSensorModal () {
      this.sensorForm =
        {
          sensorId: '',
          deviceId: '',
          group: '',
          company: '',
          category: '',
          applianceName: '',
          publishTimeout: '30',
          isActive: true,
          isConnected: null
        }
      this.$v.$reset()
    },
    resetFormModal () {
      this.newForm = {
        name: null,
        status: 'Active',
        template: [{name: null, type: null}],
        users: []
      }
      this.$v.$reset()
    },
    resetCloneModal () {

    },
    resetModal () {
      this.form.user = ''
      this.$v.$reset()
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    addUsertoGroup (e) {
      e.preventDefault()

      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      this.loading = true
      let self = this

      const addUser = this.$firebase.functions().httpsCallable('addUsertoGroup')
      addUser(this.form).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$swal({
            title: self.$t('User added to Group!'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(function (result) {
            self.fetchGroup(true)
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    printLabels () {
      this.hideForForms = false
      setTimeout(function () { print() }, 1000)
    },
    printFormResults () {
      this.hideForForms = true
      setTimeout(function () { print() }, 1000)
    },
    compare (a, b) {
      const bandA = new Date(a.recordedAt)
      const bandB = new Date(b.recordedAt)

      let comparison = 0
      if (bandA > bandB) {
        comparison = 1
      } else if (bandA < bandB) {
        comparison = -1
      }
      return comparison
    },
    showDevice (item) {
      this.showDeviceBool = true
      this.fetchDeviceSensors(item.gatewayId)
      this.deviceShown = {
        gatewayId: item.gatewayId,
        gatewayName: item.gatewayName
      }
    },
    fetchDeviceSensors (id) {
      console.log('fetching sensors')
      var self = this
      this.sensorTableIsBusy = true
      let params = {
        'gatewayId': id,
        'group': this.$route.params.id,
        'company': '',
        'category': this.group.categoryId ? this.group.categoryId : ''
      }

      if (this.$route.params.company != null) {
        params.company = this.$route.params.company
      } else {
        params.company = this.$store.state.user.data.companyId
      }

      console.log(params)
      const getDeviceSensors = this.$firebase.functions().httpsCallable('getSensorList')

      getDeviceSensors(params).then(function (result) {
        // success or error handling
        console.log('result', result)
        if (!result.hasOwnProperty('data')) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.deviceSensors = result.data
          // self.deviceSensors.forEach(function (device) {
          //   self.sensorsOptions.push({value: device.deviceId, text: device.applianceName})
          // })
        }
        self.sensorTableIsBusy = false
        self.loading = false
      }).catch(function (err) {
        console.log('failed to fetch sensors', err)
      })
    }
  }
}
</script>
<style>
  .element-type{
    width: 35%;
    float: left;
    padding-left: 10px;
    font-size: 12px
  }
  .element-title{
    float: left;
    font-size: 12px;
  }
  .btn-group-toggle.btn-group {
    width: 100%;
  }
  .multiselect__tags {
    min-height: unset;
    padding: 4px 40px 3px 8px;
    border-radius: 0;
  }
  span.multiselect__placeholder {
    margin-bottom: 0;
  }
  label.btn.btn-white {
    background-color: white;
    border-right: 2px solid #eff8ff;
    border-left: 2px solid #eff8ff;
  }

  label.btn.btn-white.active {
    background-color: #c8e9f8;
  }

  #haccp ul.nav-tabs {
    background: #c8e9f8;
  }

  .print_show{
    display: none;
  }

  @media print {

    @page {
      margin: 3cm 1cm 5cm;
    }
    thead { display: table-header-group !important; }
    tfoot { display: table-row-group !important; }
    tr { page-break-inside: avoid !important; }
    table { page-break-after: always !important; }
    /*.print_results{*/
      /*width: 100%;*/
      /*position: fixed;*/
      /*top: 0;*/
      /*left: 0;*/
      /*z-index: 1000000;*/
      /*background: white;*/
      /*height: 100%;*/
    /*}*/

    footer {
      /*position: fixed;*/
      /*bottom: 0;*/
      /*height: 100px;*/
      /*background: #000;*/
    }

    body {
      /*margin: 0 0 0 0;*/
    }
    .tab-content {
      border: 0 !important;
    }
    /*a {*/
      /*color: #00aeef;*/
      /*text-decoration: none;*/
    /*}*/
    .print_show{
      display: block !important;
    }
    .print_hide{
      display: none !important;
    }
    .navbar.fixed-top+.page-body-wrapper {
      background-color: transparent;
    }
    .tabs ul {
      display: none;
    }

    .main-panel {
      margin: 0;
      width: 100%;
    }
    .navbar.fixed-top+.page-body-wrapper {
      padding-top:0px !important;
    }
    .content-wrapper {
      padding: 0;
      background: transparent;
    }
    .print_title{
      width: 100%;
      text-align: center;
    }

    /*html, body {*/
      /*!*height:100vh;*!*/
      /*margin: 0 !important;*/
      /*padding: 0 !important;*/
      /*overflow: hidden;*/
    /*}*/

  }

   .bigger-width .modal-dialog {
     min-width: 700px;
   }
  i.fa.fa-align-justify.handle {
    float: left;
    font-size: 20px;
    line-height: 120px;
    padding-right: 5px;
    color: #066d97;
  }
  .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #dcdcdc;
    background-color: #00aeef;
  }
  .badge.b-form-tag.badge-light {
    padding-top: 0;
  }
  span.multiselect__option.multiselect__option--group {
    font-weight: 500;
  }

  span.multiselect__option:not(.multiselect__option--group) {
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Group.vue